export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "de-DE",
    "Messages": {
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
        "10": "10",
        "{filled} z {total} uzupełnionych": "{filled} von {total} ausgefüllt",
        "%0 rozpoczętych checkoutów": "%0 gestartete Checkouts",
        "1 dzień": "1 Tag",
        "14 dni": "14 Tage",
        "3 dni": "3 Tage",
        "7 dni": "7 Tage",
        "Adres dostawy": "Lieferadresse",
        "Adres e-mail": "E-Mail-Adresse",
        "Adres faktury": "Rechnungsadresse",
        "Adres feedu": "Feed-Adresse",
        "Adres IP": "IP-Adresse",
        "Aktualizuj cennik": "Preisliste aktualisieren",
        "Aktywna": "Aktiv",
        "Aktywne": "Aktiv",
        "Aktywność promocji": "Aktivität der Aktion",
        "Aktywny": "Aktiv",
        "Alert": "Warnung",
        "alertów": "Warnungen",
        "Anulowana": "Storniert",
        "Anulowane": "Storniert",
        "Anuluj": "Abbrechen",
        "Anuluj edycję": "Bearbeitung abbrechen",
        "API Key": "API Key",
        "API Key Location": "API-Key-Position",
        "API Key Tracking": "API-Key-Tracking",
        "Atrybuty": "Attribute",
        "Atrybuty i zawartość tego elementu są powtarzane dla każdego wpisu z wybranej listy (np. url → URL zdjęcia).": "Die Attribute und der Inhalt dieses Elements werden für jeden Eintrag aus der ausgewählten Liste wiederholt (z. B. url → URL des Bildes).",
        "Automatyczna akceptacja": "Automatische Freigabe",
        "Automatycznie tworzone podsumowanie opinii o produkcie.": "Automatisch erstellte Zusammenfassung der Produktbewertungen.",
        "Autor": "Autor",
        "Autor opinii": "Autor der Bewertung",
        "Bez adresu email": "Ohne E-Mail-Adresse",
        "Bez wyboru eksport obejmie wszystkie produkty.": "Ohne Kategorieauswahl werden alle Produkte exportiert.",
        "Bez wybranego źródła lista będzie iterować po głównej kolekcji danych.": "Wenn keine Quelle ausgewählt ist, durchläuft die Liste die Hauptdatenkollektion.",
        "Bieżący okres": "Aktueller Zeitraum",
        "Bieżący stan produktu w magazynie.": "Aktueller Lagerbestand des Produkts.",
        "Brak": "Keine",
        "Brak cech dla wybranych kategorii.": "Keine Merkmale für die ausgewählten Kategorien.",
        "Brak cech w grupie": "Keine Merkmale in der Gruppe",
        "Brak cech wariantowych w kategoriach tego produktu.": "Keine Variantenmerkmale in den Kategorien dieses Produkts.",
        "Brak cenników. Dodaj cennik dla wybranego sklepu.": "Keine Preislisten. Fügen Sie eine Preisliste für den ausgewählten Shop hinzu.",
        "Brak danych": "Keine Daten",
        "Brak dostępnych dostaw dla wybranego kraju.": "Keine verfügbaren Lieferarten für das ausgewählte Land.",
        "Brak dostępnych krajów.": "Keine verfügbaren Länder.",
        "Brak katalogów": "Keine Kataloge",
        "Brak kategorii nadrzędnej": "Keine übergeordnete Kategorie",
        "Brak kategorii w grupie": "Keine Kategorien in der Gruppe",
        "Brak komentarza": "Kein Kommentar",
        "Brak krajów": "Keine Länder",
        "Brak kwoty do rozliczenia.": "Kein abzurechnender Betrag.",
        "Brak miasta": "Keine Stadt",
        "Brak odziedziczonych cech.": "Keine geerbten Merkmale.",
        "Brak pasujących kategorii.": "Keine passenden Kategorien.",
        "Brak produktów komplementarnych.": "Keine ergänzenden Produkte.",
        "Brak produktów rekomendowanych.": "Keine empfohlenen Produkte.",
        "Brak produktów w kolekcji": "Keine Produkte in der Kollektion",
        "Brak produktów w promocji": "Keine Produkte im Angebot",
        "Brak skonfigurowanej zawartości.": "Kein Inhalt konfiguriert.",
        "Brak tłumaczenia": "Keine Übersetzung",
        "Brak treści opinii": "Kein Bewertungstext",
        "Brak w magazynie": "Nicht auf Lager",
        "Brak witryn do przypisania.": "Keine Websites zum Zuweisen.",
        "Brak wybranych etykiet": "Keine Labels ausgewählt",
        "Brak wybranych producentów": "Keine Hersteller ausgewählt",
        "Brak wybranych produktów": "Keine Produkte ausgewählt",
        "Brak wybranych wartości": "Keine Werte ausgewählt",
        "Brak zdjęcia": "Kein Bild",
        "Brak zmian statusu.": "Keine Statusänderungen.",
        "Brakuje części lub elementów zestawu": "Teile oder Elemente des Sets fehlen",
        "Brutto": "Brutto",
        "Cecha": "Merkmal",
        "Cecha nie ma jeszcze żadnych wartości.": "Das Merkmal hat noch keine Werte.",
        "Cecha służy do rozróżniania wariantów produktu. Ustawienie można wybrać tylko przy tworzeniu cechy.": "Das Merkmal dient zur Unterscheidung von Produktvarianten. Diese Einstellung kann nur beim Erstellen des Merkmals ausgewählt werden.",
        "Cecha została dodana.": "Das Merkmal wurde hinzugefügt.",
        "Cecha została usunięta.": "Das Merkmal wurde gelöscht.",
        "Cecha została zaktualizowana.": "Das Merkmal wurde aktualisiert.",
        "Cechy": "Merkmale",
        "Cechy odziedziczone po kategoriach nadrzędnych": "Von übergeordneten Kategorien geerbte Merkmale",
        "Cechy w grupie": "Merkmale in der Gruppe",
        "Cena aktualna": "Aktueller Preis",
        "Cena aktualna brutto": "Aktueller Bruttopreis",
        "Cena aktualna netto": "Aktueller Nettopreis",
        "Cena brutto": "Bruttopreis",
        "Cena brutto do": "Bruttopreis bis",
        "Cena brutto od": "Bruttopreis ab",
        "Cena do": "Preis bis",
        "Cena dostawy": "Lieferkosten",
        "Cena łączna": "Gesamtpreis",
        "Cena netto": "Nettopreis",
        "Cena netto do": "Nettopreis bis",
        "Cena netto od": "Nettopreis ab",
        "Cena od": "Preis ab",
        "Cena produktów": "Produktpreise",
        "Cena sugerowana brutto": "Empfohlener Bruttopreis",
        "Cena sugerowana dla wybranych produktów z zestawu": "Empfohlener Preis für ausgewählte Produkte aus dem Set",
        "Cena sugerowana netto": "Empfohlener Nettopreis",
        "Cena zamówienia": "Bestellpreis",
        "Cena została zdezaktywowana.": "Der Preis wurde deaktiviert.",
        "Cennik został dodany.": "Die Preisliste wurde hinzugefügt.",
        "Cennik został zaktualizowany": "Die Preisliste wurde aktualisiert",
        "Cenniki": "Preislisten",
        "Ceny": "Preise",
        "Ceny bazowe produktu w dostępnych walutach.": "Basispreise des Produkts in den verfügbaren Währungen.",
        "Ceny dostawy": "Lieferpreise",
        "Ceny elementów zestawu": "Preise der Set-Elemente",
        "Ceny w pozostałych walutach przeliczane są względem domyślnej.": "Preise in den übrigen Währungen werden anhand der Standardwährung umgerechnet.",
        "Client ID": "Client ID",
        "Client Secret": "Client Secret",
        "Co n-ty produkt gratis": "Jedes n-te Produkt gratis",
        "CRC": "CRC",
        "Customer ID": "Customer ID",
        "Cykl życia koszyka": "Lebenszyklus des Warenkorbs",
        "Czas dostawy": "Lieferzeit",
        "Czas na zgłoszenie reklamacji": "Frist für die Meldung einer Reklamation",
        "Czas na zgłoszenie zwrotu": "Frist für die Meldung einer Rücksendung",
        "Czas realizacji oraz dni i godziny wysyłki zamówień.": "Bearbeitungszeit sowie Versandtage und -zeiten für Bestellungen.",
        "Członkowie grupy klientów": "Mitglieder der Kundengruppe",
        "Czy na pewno chcesz usunąć ten atrybut?": "Möchten Sie dieses Attribut wirklich löschen?",
        "Czy na pewno chcesz usunąć ten element?": "Möchten Sie dieses Element wirklich löschen?",
        "Czy na pewno chcesz usunąć ten warunek?": "Möchten Sie diese Bedingung wirklich löschen?",
        "Dane adresowe zapisane w zamówieniu.": "In der Bestellung gespeicherte Adressdaten.",
        "Dane do faktury": "Rechnungsdaten",
        "Dane dokumentu i rozliczenie należności.": "Dokumentdaten und Abrechnung der Forderungen.",
        "Dane faktury": "Rechnungsdaten",
        "Dane grupy": "Gruppendaten",
        "Dane klienta": "Kundendaten",
        "Dane kraju": "Länderdaten",
        "Dane połączenia z operatorem dostawy.": "Verbindungsdaten zum Lieferdienstleister.",
        "Dane sklepu oraz sposób prezentacji cen.": "Shopdaten und Preisdarstellung.",
        "Dane zostały zapisane": "Die Daten wurden gespeichert",
        "Darmowa dostawa": "Kostenloser Versand",
        "Darmowa dostawa od kwoty (brutto)": "Kostenloser Versand ab einem Betrag (brutto)",
        "Darmowa przesyłka od kwoty (brutto)": "Kostenlose Lieferung ab einem Betrag (brutto)",
        "Darmowy produkt": "Kostenloses Produkt",
        "Data": "Datum",
        "Data do": "Datum bis",
        "Data dodania": "Hinzugefügt am",
        "Data modyfikacji": "Änderungsdatum",
        "Data modyfikacji pliku": "Änderungsdatum der Datei",
        "Data oceny": "Bewertungsdatum",
        "Data od": "Datum ab",
        "Data ostatniego zamówienia": "Datum der letzten Bestellung",
        "Data płatności": "Zahlungsdatum",
        "Data reklamacji": "Reklamationsdatum",
        "Data rozpoczęcia": "Startdatum",
        "Data rozpoczęcia publikacji jest wymagana": "Das Veröffentlichungsstartdatum ist erforderlich",
        "Data rozpoczęcia rekomendacji": "Startdatum der Empfehlung",
        "Data ustawienia": "Einstellungsdatum",
        "Data utworzenia": "Erstellungsdatum",
        "Data zakończenia": "Enddatum",
        "Data zakończenia rekomendacji": "Enddatum der Empfehlung",
        "Data zamówienia": "Bestelldatum",
        "Data zmiany ceny": "Datum der Preisänderung",
        "Dev": "Dev",
        "Dezaktywacja ceny jest nieodwracalna, a zdezaktywowana cena nie będzie brana pod uwagę przy obliczaniu najniższej ceny.": "Die Deaktivierung des Preises kann nicht rückgängig gemacht werden. Der deaktivierte Preis wird bei der Berechnung des niedrigsten Preises nicht berücksichtigt.",
        "Dezaktywacja zmiany ceny": "Preisänderung deaktivieren",
        "Dezaktywuj": "Deaktivieren",
        "Dezaktywuj zmianę ceny": "Preisänderung deaktivieren",
        "Dhl": "DHL",
        "Długość kodu": "Codelänge",
        "dni": "Tage",
        "Do wysłania": "Zu versenden",
        "Dodaj": "Hinzufügen",
        "Dodaj atrybut": "Attribut hinzufügen",
        "Dodaj cechę": "Merkmal hinzufügen",
        "Dodaj cechę do grupy": "Merkmal zur Gruppe hinzufügen",
        "Dodaj cennik": "Preisliste hinzufügen",
        "Dodaj eksport": "Export hinzufügen",
        "Dodaj element": "Element hinzufügen",
        "Dodaj etykietę": "Etikett hinzufügen",
        "Dodaj fakturę": "Rechnung hinzufügen",
        "Dodaj grupę cech": "Merkmalsgruppe hinzufügen",
        "Dodaj grupę klientów": "Kundengruppe hinzufügen",
        "Dodaj katalog": "Katalog hinzufügen",
        "Dodaj katalog, aby rozpocząć zarządzanie kategoriami.": "Fügen Sie einen Katalog hinzu, um mit der Verwaltung der Kategorien zu beginnen.",
        "Dodaj kategorię": "Kategorie hinzufügen",
        "Dodaj kody": "Codes hinzufügen",
        "Dodaj kolekcję": "Kollektion hinzufügen",
        "Dodaj kraj": "Land hinzufügen",
        "Dodaj notatkę": "Notiz hinzufügen",
        "Dodaj parametr UTM": "UTM-Parameter hinzufügen",
        "Dodaj pierwszy element struktury.": "Fügen Sie das erste Strukturelement hinzu.",
        "Dodaj poniżej": "Darunter hinzufügen",
        "Dodaj powiadomienie": "Benachrichtigung hinzufügen",
        "Dodaj powiązanie": "Verknüpfung hinzufügen",
        "Dodaj powyżej": "Darüber hinzufügen",
        "Dodaj producenta": "Hersteller hinzufügen",
        "Dodaj produkt": "Produkt hinzufügen",
        "Dodaj produkt do kolekcji": "Produkt zur Kollektion hinzufügen",
        "Dodaj promocję": "Aktion hinzufügen",
        "Dodaj promocję wiązaną": "Bundle-Aktion hinzufügen",
        "Dodaj przecenę": "Rabatt hinzufügen",
        "Dodaj sklep": "Shop hinzufügen",
        "Dodaj sposób dostawy": "Versandart hinzufügen",
        "Dodaj sposób płatności": "Zahlungsart hinzufügen",
        "Dodaj stawkę": "Steuersatz hinzufügen",
        "Dodaj użytkownika": "Benutzer hinzufügen",
        "Dodaj walutę": "Währung hinzufügen",
        "Dodaj wartość": "Wert hinzufügen",
        "Dodaj warunek": "Bedingung hinzufügen",
        "Dodaj wewnątrz": "Innerhalb hinzufügen",
        "Dodaj właściwość": "Eigenschaft hinzufügen",
        "Dodaj wpis w kalendarzu": "Kalendereintrag hinzufügen",
        "Dodaj zakres": "Bereich hinzufügen",
        "Dodane przez": "Hinzugefügt von",
        "Dodanie cechy": "Merkmal hinzufügen",
        "Dodanie cennika": "Preisliste hinzufügen",
        "Dodanie eksportu": "Export hinzufügen",
        "Dodanie etykiety": "Etikett hinzufügen",
        "Dodanie faktury": "Rechnung hinzufügen",
        "Dodanie grupy cech": "Merkmalsgruppe hinzufügen",
        "Dodanie grupy klientów": "Kundengruppe hinzufügen",
        "Dodanie kategorii": "Kategorie hinzufügen",
        "Dodanie kolekcji": "Kollektion hinzufügen",
        "Dodanie kraju": "Land hinzufügen",
        "Dodanie opcji dostawy": "Versandoption hinzufügen",
        "Dodanie opcji płatności": "Zahlungsoption hinzufügen",
        "Dodanie parametru UTM": "UTM-Parameter hinzufügen",
        "Dodanie powiadomienia": "Benachrichtigung hinzufügen",
        "Dodanie producenta": "Hersteller hinzufügen",
        "Dodanie produktu": "Produkt hinzufügen",
        "Dodanie promocji kodów rabatowych": "Rabattcode-Aktion hinzufügen",
        "Dodanie promocji wiązanej": "Bundle-Aktion hinzufügen",
        "Dodanie przeceny produktów": "Produktrabatt hinzufügen",
        "Dodanie sklepów": "Shops hinzufügen",
        "Dodanie stawki": "Steuersatz hinzufügen",
        "Dodanie waluty": "Währung hinzufügen",
        "Dodanie wartości": "Wert hinzufügen",
        "Dodanie wpisu do kalendarza": "Kalendereintrag hinzufügen",
        "Dodano do koszyka": "In den Warenkorb gelegt",
        "Dodatkowe informacje o przeznaczeniu grupy.": "Zusätzliche Informationen zum Zweck der Gruppe.",
        "Dodatkowe materiały wizualne kolekcji.": "Zusätzliches Bildmaterial der Kollektion.",
        "Dodatkowe objaśnienie wartości. Treść można przygotować osobno dla każdego języka.": "Zusätzliche Erläuterung des Werts. Der Text kann für jede Sprache separat erstellt werden.",
        "Dodatkowe pola dla reklamacji": "Zusätzliche Felder für Reklamationen",
        "Dodatkowe wymagania dotyczące dostawy.": "Zusätzliche Lieferanforderungen.",
        "Dodawaj, edytuj i porządkuj wartości.": "Werte hinzufügen, bearbeiten und sortieren.",
        "Dodawanie elementów": "Elemente hinzufügen",
        "Dodawanie kodów": "Codes hinzufügen",
        "Dodawanie produktów, wybór kategorii lub import CSV.": "Produkte hinzufügen, Kategorie auswählen oder CSV importieren.",
        "Dokonaj dopłaty": "Zuzahlung leisten",
        "Dokument faktury w formacie PDF.": "Rechnungsdokument im PDF-Format.",
        "Dokument jest pusty": "Das Dokument ist leer",
        "Dokumenty i pliki do pobrania, maksymalnie 10 plików.": "Dokumente und Dateien zum Herunterladen, maximal 10 Dateien.",
        "Domyślna waluta": "Standardwährung",
        "Domyślny limit (brutto)": "Standardlimit (brutto)",
        "Dopłać": "Zuzahlen",
        "Dopłacenie faktury": "Rechnung nachzahlen",
        "Dostawa": "Lieferung",
        "Dostawa na palecie": "Lieferung auf Palette",
        "Dostawa w godzinach wieczornych": "Lieferung in den Abendstunden",
        "Dostawa w sobotę": "Lieferung am Samstag",
        "Dostawie nie przypisano żadnych form płatności": "Der Lieferung sind keine Zahlungsarten zugeordnet",
        "Dostawy": "Lieferungen",
        "Dostawy dla wybranego kraju oraz przypisane do nich formy płatności.": "Lieferungen für das ausgewählte Land und die ihnen zugeordneten Zahlungsarten.",
        "Dostawy dostępne w kraju wybranego sklepu.": "Lieferungen, die im Land des ausgewählten Shops verfügbar sind.",
        "Dostawy i płatności": "Lieferungen und Zahlungen",
        "Dostępna liczba kodów możliwych do wygenerowania:": "Verfügbare Anzahl generierbarer Codes:",
        "Dostępne metody płatności": "Verfügbare Zahlungsmethoden",
        "Dostępność i ilości": "Verfügbarkeit und Mengen",
        "Dostępność kolekcji w sklepie.": "Verfügbarkeit der Kollektion im Shop.",
        "Dostępny w magazynie": "Auf Lager",
        "Dotpay": "Dotpay",
        "Dotyczy niezalogowanych klientów.": "Gilt für nicht angemeldete Kunden.",
        "Drugi klucz (MD5)": "Zweiter Schlüssel (MD5)",
        "Działania masowe": "Massenaktionen",
        "Dzień wysyłki": "Versandtag",
        "E-mail": "E-Mail",
        "EAN-13": "EAN-13",
        "Edycja": "Bearbeiten",
        "Edycja cechy": "Merkmal bearbeiten",
        "Edycja cennika": "Preisliste bearbeiten",
        "Edycja eksportu": "Export bearbeiten",
        "Edycja etykiety": "Etikett bearbeiten",
        "Edycja grupy cech": "Merkmalsgruppe bearbeiten",
        "Edycja grupy klientów": "Kundengruppe bearbeiten",
        "Edycja kategorii": "Kategorie bearbeiten",
        "Edycja kodu rabatowego": "Rabattcode bearbeiten",
        "Edycja kolekcji": "Kollektion bearbeiten",
        "Edycja kraju": "Land bearbeiten",
        "Edycja opcji dostawy": "Versandoption bearbeiten",
        "Edycja opcji płatności": "Zahlungsoption bearbeiten",
        "Edycja parametru UTM": "UTM-Parameter bearbeiten",
        "Edycja powiadomienia": "Benachrichtigung bearbeiten",
        "Edycja producenta": "Hersteller bearbeiten",
        "Edycja produktu": "Produkt bearbeiten",
        "Edycja promocji kodów rabatowych": "Rabattcode-Aktion bearbeiten",
        "Edycja promocji wiązanej": "Bundle-Aktion bearbeiten",
        "Edycja przeceny": "Rabatt bearbeiten",
        "Edycja przeceny produktów": "Produktrabatt bearbeiten",
        "Edycja sklepów": "Shops bearbeiten",
        "Edycja stawki": "Steuersatz bearbeiten",
        "Edycja stawki podatku": "Steuersatz bearbeiten",
        "Edycja waluty": "Währung bearbeiten",
        "Edycja wartości": "Wert bearbeiten",
        "Edycja wpisu do kalendarza": "Kalendereintrag bearbeiten",
        "Edytuj": "Bearbeiten",
        "Edytuj adres": "Adresse bearbeiten",
        "Edytuj notatkę": "Notiz bearbeiten",
        "Edytuj treść": "Inhalt bearbeiten",
        "Edytuj treść opinii": "Bewertungstext bearbeiten",
        "Efekt": "Effekt",
        "Efekty promocji": "Aktionswirkungen",
        "Eksport kodów rabatowych został uruchomiony": "Der Export der Rabattcodes wurde gestartet",
        "Eksport został dodany.": "Der Export wurde hinzugefügt.",
        "Eksport został usunięty.": "Der Export wurde gelöscht.",
        "Eksport został zaktualizowany.": "Der Export wurde aktualisiert.",
        "Eksportuj": "Exportieren",
        "Eksportuj CSV": "CSV exportieren",
        "Eksporty": "Exporte",
        "Element": "Element",
        "Element nie posiada jeszcze żadnych atrybutów": "Das Element hat noch keine Attribute",
        "Element nie posiada jeszcze żadnych warunków": "Das Element hat noch keine Bedingungen",
        "Elementy zestawu": "Elemente des Sets",
        "Etykieta": "Etikett",
        "Etykieta priorytetowa": "Prioritätsetikett",
        "Etykieta produktu została dodana.": "Das Produktetikett wurde hinzugefügt.",
        "Etykieta produktu została usunięta.": "Das Produktetikett wurde gelöscht.",
        "Etykieta produktu została zaktualizowana.": "Das Produktetikett wurde aktualisiert.",
        "Etykiety": "Etiketten",
        "Etykiety produktów": "Produktetiketten",
        "Etykiety wyróżniające ten produkt w sklepie.": "Etiketten, die dieses Produkt im Shop hervorheben.",
        "Faktura": "Rechnung",
        "Faktura rozliczona w całości": "Rechnung vollständig beglichen",
        "Faktura została dodana.": "Die Rechnung wurde hinzugefügt.",
        "Faktura została zaktualizowana.": "Die Rechnung wurde aktualisiert.",
        "Fakturę utwórz z poziomu zamówienia.": "Erstellen Sie die Rechnung über die Bestellung.",
        "Faktury": "Rechnungen",
        "Fałsz": "Falsch",
        "Firma": "Unternehmen",
        "Filtry produktów": "Produktfilter",
        "Format": "Format",
        "Format cen i progi naliczania kosztów dostawy.": "Format der Preise und Schwellenwerte für die Berechnung der Versandkosten.",
        "Format ceny": "Preisformat",
        "Format i źródło określają strukturę feedu.": "Format und Quelle bestimmen die Struktur des Feeds.",
        "Format kodu pocztowego": "Postleitzahlenformat",
        "Format kodu powinien być wyrażeniem regularnym.": "Das Codeformat sollte ein regulärer Ausdruck sein.",
        "Formularz": "Formular",
        "Formy płatności powiązane z tą metodą dostawy.": "Zahlungsarten, die mit dieser Versandart verknüpft sind.",
        "Galeria zdjęć produktu, maksymalnie 10 plików.": "Produktfotogalerie, maximal 10 Dateien.",
        "Generowanie feedu zostało uruchomione.": "Die Feed-Generierung wurde gestartet.",
        "Generowanie kodów": "Codegenerierung",
        "Generowanie korzysta z ostatnio zapisanej konfiguracji.": "Für die Generierung wird die zuletzt gespeicherte Konfiguration verwendet.",
        "Generowanie, dopisywanie i obsługa indywidualnych kodów.": "Generierung, Hinzufügen und Verwaltung individueller Codes.",
        "Generuj nowe kody": "Neue Codes generieren",
        "Generuj opis": "Beschreibung generieren",
        "Generuj opis produktu na podstawie parametrów": "Produktbeschreibung anhand der Parameter generieren",
        "Generuj warianty": "Varianten generieren",
        "Generuj wszystkie metadane": "Alle Metadaten generieren",
        "Głębokość": "Tiefe",
        "Głębokość paczki": "Pakettiefe",
        "Godzina rozpoczęcia": "Startzeit",
        "Godzina wysyłki": "Versandzeit",
        "Godzina wysyłki: {day}": "Versandzeit: {day}",
        "Godzina zakończenia": "Endzeit",
        "Grafika identyfikująca sposób płatności w sklepie.": "Grafik zur Kennzeichnung der Zahlungsart im Shop.",
        "Grafika reprezentująca kolekcję.": "Grafik zur Darstellung der Kollektion.",
        "Grafika wyświetlana przy tej metodzie dostawy.": "Grafik, die bei dieser Versandart angezeigt wird.",
        "Grafiki wykorzystywane do prezentacji kategorii.": "Grafiken zur Darstellung der Kategorien.",
        "Grupa cech": "Merkmalsgruppe",
        "Grupa cech została dodana.": "Die Merkmalsgruppe wurde hinzugefügt.",
        "Grupa cech została usunięta.": "Die Merkmalsgruppe wurde gelöscht.",
        "Grupa cech została zaktualizowana.": "Die Merkmalsgruppe wurde aktualisiert.",
        "Grupa klientów": "Kundengruppe",
        "Grupa klientów aktywna": "Kundengruppe aktiv",
        "Grupa klientów została dodana.": "Die Kundengruppe wurde hinzugefügt.",
        "Grupa klientów została usunięta.": "Die Kundengruppe wurde gelöscht.",
        "Grupa klientów została zaktualizowana.": "Die Kundengruppe wurde aktualisiert.",
        "Grupy cech": "Merkmalsgruppen",
        "Grupy klientów": "Kundengruppen",
        "Happy hours": "Happy Hour",
        "Hasło użytkownika": "Benutzerpasswort",
        "Historia faktur": "Rechnungsverlauf",
        "Historia powiadomień": "Benachrichtigungsverlauf",
        "Historia przeglądania produktów": "Produktaufrufverlauf",
        "Historia przeglądanych produktów": "Verlauf der angesehenen Produkte",
        "Historia statusów": "Statusverlauf",
        "Historia wersji": "Versionsverlauf",
        "Historia zamówień powiązanych z tym klientem.": "Verlauf der mit diesem Kunden verknüpften Bestellungen.",
        "Historia zmian cen produktu": "Verlauf der Produktpreisänderungen",
        "Historia zmian ceny": "Verlauf der Preisänderungen",
        "Id": "ID",
        "ID": "ID",
        "ID autora": "Autor-ID",
        "ID katalogu": "Katalog-ID",
        "ID kategorii głównej": "ID der Hauptkategorie",
        "ID kategorii nadrzędnej": "ID der übergeordneten Kategorie",
        "ID organizacji": "Organisations-ID",
        "ID podatku": "Steuer-ID",
        "Id punktu płatności (pos_id)": "Zahlungspunkt-ID (pos_id)",
        "ID sklepu": "Shop-ID",
        "ID użytkownika": "Benutzer-ID",
        "ID użytkownika modyfikującego": "ID des bearbeitenden Benutzers",
        "Identyfikator i wartości używane do oznaczania ruchu.": "Kennung und Werte zur Kennzeichnung des Traffics.",
        "Identyfikator klienta w koncie DHL.": "Kundenkennung im DHL-Konto.",
        "Identyfikator organizacji w koncie InPost.": "Organisationskennung im InPost-Konto.",
        "Identyfikator sklepu (domyślnie id sprzedawcy)": "Shop-ID (standardmäßig die Verkäufer-ID)",
        "Identyfikator sprzedawcy": "Verkäufer-ID",
        "Identyfikator używany do rozpoznawania grupy w systemie.": "Kennung zur Identifizierung einer Gruppe im System.",
        "Identyfikatory": "Kennungen",
        "Ikona wartości": "Wert-Icon",
        "Ilość": "Menge",
        "Ilość dni po porzuceniu koszyka": "Anzahl der Tage nach dem Abbruch des Warenkorbs",
        "Ilość ocen": "Anzahl der Bewertungen",
        "Ilość polubień": "Anzahl der Likes",
        "Ilość porzuconych koszyków": "Anzahl der abgebrochenen Warenkörbe",
        "Ilość powtórzeń po wystąpieniu błędu": "Anzahl der Wiederholungen nach einem Fehler",
        "Ilość produktu pozostawiana w magazynie. Pierwszeństwo ma ustawienie wariantu, następnie produktu, a na końcu kategorii.": "Produktmenge, die im Lager verbleibt. Vorrang hat die Einstellung der Variante, gefolgt vom Produkt und schließlich der Kategorie.",
        "Ilość produktu w zestawie": "Produktmenge im Set",
        "Ilość reklamacji": "Anzahl der Reklamationen",
        "Ilość reklamowana": "Reklamierte Menge",
        "Ilość w magazynie": "Lagerbestand",
        "Ilość w magazynie do": "Lagerbestand bis",
        "Ilość w magazynie od": "Lagerbestand ab",
        "Ilość zamówień": "Anzahl der Bestellungen",
        "Ilość zwracana": "Zurückgegebene Menge",
        "Ilości zarezerwowane w zamówieniach.": "In Bestellungen reservierte Mengen.",
        "Imię": "Vorname",
        "Imię i nazwisko": "Vor- und Nachname",
        "Imię klienta": "Vorname des Kunden",
        "Import CSV kategorii": "CSV-Import von Kategorien",
        "Import CSV produktów": "CSV-Import von Produkten",
        "Import CSV zastąpi bieżącą listę produktów.": "Der CSV-Import ersetzt die aktuelle Produktliste.",
        "Import kategorii został rozpoczęty.": "Der Import der Kategorien wurde gestartet.",
        "Import produktów został rozpoczęty.": "Der Produktimport wurde gestartet.",
        "Importuj": "Importieren",
        "Importuj CSV": "CSV importieren",
        "Importuj schemat": "Schema importieren",
        "Indywidualny": "Individuell",
        "Informacja dla klienta przy wyborze tej metody dostawy.": "Information für den Kunden bei Auswahl dieser Versandart.",
        "Informacje o produkcie": "Produktinformationen",
        "Informacyjna": "Informativ",
        "Inny powód": "Anderer Grund",
        "Inny problem z produktem": "Anderes Problem mit dem Produkt",
        "Inpost": "InPost",
        "Iteracja nastąpi po głównej kolekcji danych": "Die Iteration erfolgt nach der Hauptdatensammlung",
        "Iteracja po...": "Iteration über ...",
        "Jakość produktu nie spełnia oczekiwań": "Die Produktqualität entspricht nicht den Erwartungen",
        "Jednostka marginesu": "Randeinheit",
        "Jednostka marginesu ilościowego": "Einheit des Mengenrands",
        "Jeśli nazwa wyświetlana nie zostanie ustawiona, zostanie użyta nazwa kategorii.": "Wenn kein Anzeigename festgelegt ist, wird der Kategoriename verwendet.",
        "Jeśli nie wybrano żadnego produktu, promocja obejmuje wszystkie produkty bez żadnych ograniczeń.": "Wenn kein Produkt ausgewählt wurde, gilt die Aktion uneingeschränkt für alle Produkte.",
        "Język": "Sprache",
        "Języki witryny {name}": "Sprachen der Website {name}",
        "JSON konfiguracji": "Konfigurations-JSON",
        "JSON nie jest zgodny z konfiguracją eksportu (name, source, format, schema).": "Das JSON entspricht nicht der Exportkonfiguration (name, source, format, schema).",
        "Kalendarz": "Kalender",
        "Kampania (utm_campaign)": "Kampagne (utm_campaign)",
        "Kampanie": "Kampagnen",
        "Katalog": "Katalog",
        "Katalog jest pusty.": "Der Katalog ist leer.",
        "Katalog kategorii": "Kategoriekatalog",
        "Katalog produktów": "Produktkatalog",
        "Katalog z kategoriami został skopiowany.": "Katalog und Kategorien wurden kopiert.",
        "Katalog został usunięty.": "Der Katalog wurde gelöscht.",
        "Katalog został utworzony.": "Der Katalog wurde erstellt.",
        "Katalogi kategorii": "Kategoriekataloge",
        "Kategoria": "Kategorie",
        "Kategoria główna": "Hauptkategorie",
        "Kategoria nadrzędna": "Übergeordnete Kategorie",
        "Kategoria widoczna": "Sichtbare Kategorie",
        "Kategoria została dodana.": "Die Kategorie wurde hinzugefügt.",
        "Kategoria została usunięta.": "Die Kategorie wurde gelöscht.",
        "Kategoria została zaktualizowana.": "Die Kategorie wurde aktualisiert.",
        "Kategorie": "Kategorien",
        "Kategorie, reguła podatku i producent.": "Kategorien, Steuerregel und Hersteller.",
        "Kategoryzacja": "Kategorisierung",
        "Klienci": "Kunden",
        "Klient": "Kunde",
        "Kliknij kategorię w drzewie po lewej, aby skonfigurować jej ustawienia, cechy i metadane.": "Klicken Sie im Baum links auf eine Kategorie, um deren Einstellungen, Merkmale und Metadaten zu konfigurieren.",
        "Klucz API do śledzenia przesyłek.": "API-Schlüssel zur Sendungsverfolgung.",
        "Klucz API punktów odbioru DHL.": "API-Schlüssel für DHL-Abholpunkte.",
        "Klucz dostępu do API obsługującego przesyłki DHL.": "Zugriffsschlüssel für die API zur Abwicklung von DHL-Sendungen.",
        "Kod": "Code",
        "Kod ISO": "ISO-Code",
        "Kod pocztowy": "Postleitzahl",
        "Kod promocyjny": "Aktionscode",
        "Kod rabatowy": "Rabattcode",
        "Kod, symbol i zasady przeliczania cen.": "Code, Symbol und Regeln zur Preisumrechnung.",
        "Kodowanie (encoding)": "Kodierung (Encoding)",
        "Kody identyfikujące produkt i jego pochodzenie.": "Codes zur Identifizierung des Produkts und seiner Herkunft.",
        "Kody promocyjne zostały dodane.": "Aktionscodes wurden hinzugefügt.",
        "Kody promocyjne zostały wygenerowane.": "Aktionscodes wurden generiert.",
        "Kody rabatowe": "Rabattcodes",
        "Kody zostały zdezaktywowane.": "Die Codes wurden deaktiviert.",
        "Kolejność wartości została zapisana.": "Die Reihenfolge der Werte wurde gespeichert.",
        "Kolekcja": "Kollektion",
        "Kolekcja aktywna": "Aktive Kollektion",
        "Kolekcja została dodana.": "Die Kollektion wurde hinzugefügt.",
        "Kolekcja została usunięta.": "Die Kollektion wurde gelöscht.",
        "Kolekcja została zaktualizowana.": "Die Kollektion wurde aktualisiert.",
        "Kolekcje": "Kollektionen",
        "Kolekcje, do których należy produkt.": "Kollektionen, zu denen das Produkt gehört.",
        "Kolor / wzór nie odpowiada": "Farbe / Muster stimmt nicht überein",
        "Kolor dekoracji tekstu": "Textdekorationsfarbe",
        "Kolor obramowania": "Rahmenfarbe",
        "Kolor tekstu": "Textfarbe",
        "Kolor tła": "Hintergrundfarbe",
        "Kolory": "Farben",
        "Kolory tła, tekstu, obramowania i dekoracji.": "Hintergrund-, Text-, Rahmen- und Dekorationsfarben.",
        "Kolumna": "Spalte",
        "Kolumna ID musi zawierać dodatnie identyfikatory produktów.": "Die Spalte „ID“ muss positive Produkt-IDs enthalten.",
        "Kolumna importu": "Imports palte",
        "Kolumna używana do wczytywania produktów": "Spalte zum Laden von Produkten",
        "Komentarz": "Kommentar",
        "Komentarz do zamówienia": "Kommentar zur Bestellung",
        "Kończy się na": "Endet mit",
        "Konfiguracja": "Konfiguration",
        "Konfiguracja eksportu została załadowana.": "Die Exportkonfiguration wurde geladen.",
        "Konfiguracja wybranego operatora płatności.": "Konfiguration des ausgewählten Zahlungsanbieters.",
        "Konfiguruj kategorię": "Kategorie konfigurieren",
        "Kopiuj": "Kopieren",
        "Kopiuj adres": "Adresse kopieren",
        "Kopiuj katalog z kategoriami": "Katalog und Kategorien kopieren",
        "Kopiuj punkt odbioru": "Abholpunkt kopieren",
        "Koszt dostawy": "Lieferkosten",
        "Koszt dostawy w państwach": "Lieferkosten in den Ländern",
        "Koszt dostawy: {country}": "Lieferkosten: {country}",
        "Koszt płatności": "Zahlungsgebühr",
        "Koszt płatności brutto": "Zahlungsgebühr brutto",
        "Koszt płatności: {country}": "Zahlungsgebühr: {country}",
        "Koszty wysyłki": "Versandkosten",
        "Koszyk usuwany": "Warenkorb wird gelöscht",
        "Koszyk uznany za opuszczony": "Warenkorb als abgebrochen markiert",
        "Koszyki": "Warenkörbe",
        "Kraj": "Land",
        "Kraj określa dostępne stawki podatku oraz sposoby dostawy i płatności.": "Das Land bestimmt die verfügbaren Steuersätze sowie die Liefer- und Zahlungsarten.",
        "Kraj produkcji": "Herstellungsland",
        "Kraj rozliczenia i reguła podatku dla kosztów dostawy.": "Abrechnungsland und Steuerregel für die Lieferkosten.",
        "Kraj rozliczenia kosztów dostawy. Po utworzeniu nie można go zmienić.": "Abrechnungsland der Lieferkosten. Nach der Erstellung kann es nicht mehr geändert werden.",
        "Kraj został dodany.": "Das Land wurde hinzugefügt.",
        "Kraj został usunięty.": "Das Land wurde gelöscht.",
        "Kraj został zaktualizowany.": "Das Land wurde aktualisiert.",
        "Kraje": "Länder",
        "Kraje produkcji": "Herstellungsländer",
        "Krótki opis prezentowany przy produkcie.": "Kurze Beschreibung, die beim Produkt angezeigt wird.",
        "Krótki opis wartości…": "Kurze Beschreibung des Werts…",
        "Krótki opis, który ułatwi administratorom rozpoznanie przeznaczenia sklepu.": "Kurze Beschreibung, die Administratoren hilft, den Zweck des Shops zu erkennen.",
        "Kurs": "Wechselkurs",
        "Kurs podawany za tyle jednostek waluty.": "Wechselkurs, angegeben für diese Anzahl von Währungseinheiten.",
        "Kurs względem waluty domyślnej, podawany dla liczby jednostek określonej mnożnikiem.": "Wechselkurs gegenüber der Standardwährung, angegeben für die durch den Multiplikator festgelegte Anzahl von Einheiten.",
        "Kwota": "Betrag",
        "Kwota brutto": "Bruttobetrag",
        "Kwota dopłaty": "Zuzahlungsbetrag",
        "Kwota netto": "Nettobetrag",
        "Kwotowy": "Betragsbezogen",
        "Łącznie": "Insgesamt",
        "Legacy": "Legacy",
        "Liczba": "Anzahl",
        "Liczba dni od ostatniej aktywności klienta.": "Anzahl der Tage seit der letzten Aktivität des Kunden.",
        "Liczba dni przechowywania": "Aufbewahrungsdauer in Tagen",
        "Liczba kategorii głównych": "Anzahl der Hauptkategorien",
        "Liczba nowych kodów": "Anzahl neuer Codes",
        "Liczba użyć": "Anzahl der Verwendungen",
        "Liczba wyników": "Anzahl der Ergebnisse",
        "Liczba wyświetlanych produktów": "Anzahl der angezeigten Produkte",
        "Liczba zamówień": "Anzahl der Bestellungen",
        "Liczony od utworzenia rezerwacji. Wpisz co najmniej 1 minutę.": "Wird ab der Erstellung der Reservierung berechnet. Geben Sie mindestens 1 Minute ein.",
        "Liczony od zmiany statusu zamówienia na Zrealizowane.": "Wird ab der Änderung des Bestellstatus auf „Abgeschlossen“ berechnet.",
        "Limit czasowy rezerwacji": "Zeitlimit für Reservierungen",
        "Limit kupiecki": "Kauflimit",
        "Limity logistyczne": "Logistiklimits",
        "Link do pełnej dokumentacji": "Link zur vollständigen Dokumentation",
        "Lista": "Liste",
        "Logo": "Logo",
        "Logo i płatności": "Logo und Zahlungen",
        "Logo sposobu płatności": "Logo der Zahlungsart",
        "Logo, zdjęcie i pliki producenta.": "Logo, Bild und Dateien des Herstellers.",
        "Lub (or)": "Oder (or)",
        "Lub wpisz wartość": "Oder geben Sie einen Wert ein",
        "Lub wybierz kolumnę CSV": "Oder wählen Sie eine CSV-Spalte aus",
        "Maksimum logistyczne": "Logistisches Maximum",
        "Maksymalna liczba pozycji przechowywanych w historii.": "Maximale Anzahl der im Verlauf gespeicherten Einträge.",
        "Maksymalna liczba produktów": "Maximale Anzahl von Produkten",
        "Maksymalna liczba użyć": "Maximale Anzahl der Verwendungen",
        "Maksymalna wartość rabatu": "Maximaler Rabattwert",
        "Maksymalna wartość zamówienia": "Maximaler Bestellwert",
        "Maksymalny poziom logistyczny zapasu produktów.": "Maximaler logistischer Lagerbestand der Produkte.",
        "Margines dla produktów": "Marge für Produkte",
        "Margines ilościowy": "Mengenmarge",
        "Marketing": "Marketing",
        "Media": "Medien",
        "Medium (utm_medium)": "Medium (utm_medium)",
        "Metadane": "Metadaten",
        "Miasto": "Stadt",
        "min": "min",
        "Miniaturka": "Miniaturansicht",
        "Minimalna i maksymalna ilość produktu.": "Mindest- und Höchstmenge des Produkts.",
        "Minimalny poziom logistyczny zapasu produktów.": "Minimaler logistischer Lagerbestand der Produkte.",
        "Minimum logistyczne": "Logistisches Minimum",
        "Mniejsze lub równe": "Kleiner oder gleich",
        "Mniejsze niż": "Kleiner als",
        "Mnożnik": "Multiplikator",
        "Moduł dostawy": "Versandmodul",
        "Moduł płatności": "Zahlungsmodul",
        "Modułu nie można zmienić po utworzeniu.": "Das Modul kann nach dem Erstellen nicht geändert werden.",
        "MPN": "MPN",
        "Multimedia": "Multimedia",
        "Na status": "In Status",
        "Nadkreślenie": "Überstreichung",
        "Najgłębszy poziom kategorii, na którym mają pojawić się kafelki.": "Tiefste Kategorieebene, auf der Kacheln angezeigt werden sollen.",
        "Najniższa cena z 30 dni brutto": "Niedrigster Bruttopreis der letzten 30 Tage",
        "Najpierw wybierz wariant przeliczenia": "Wählen Sie zuerst die Umrechnungsvariante aus",
        "Najpierw zapisz wprowadzone zmiany": "Speichern Sie zuerst die vorgenommenen Änderungen",
        "Nazwa": "Name",
        "Nazwa atrybutu": "Attributname",
        "Nazwa cechy": "Merkmalsname",
        "Nazwa eksportu": "Exportname",
        "Nazwa elementu": "Elementname",
        "Nazwa etapu": "Phasenname",
        "Nazwa firmy": "Firmenname",
        "Nazwa grupy cech": "Merkmalsgruppenname",
        "Nazwa grupy w panelu oraz jej wersje wyświetlane w sklepie.": "Name der Gruppe im Panel und deren im Shop angezeigte Versionen.",
        "Nazwa grupy wyświetlana w panelu administracyjnym.": "Name der im Administrationsbereich angezeigten Gruppe.",
        "Nazwa i identyfikator kolekcji produktów.": "Name und ID der Produktkollektion.",
        "Nazwa i okres obowiązywania wpisu.": "Name und Gültigkeitszeitraum des Eintrags.",
        "Nazwa i zasady działania grupy klientów.": "Name und Funktionsweise der Kundengruppe.",
        "Nazwa katalogu": "Katalogname",
        "Nazwa kategorii używana w panelu oraz jako domyślna nazwa wyświetlana.": "Kategoriename im Panel und standardmäßig angezeigter Name.",
        "Nazwa klienta": "Kundenname",
        "Nazwa kolekcji": "Kollektionname",
        "Nazwa parametru": "Parametername",
        "Nazwa pokazywana klientowi w wybranym języku.": "Name, der dem Kunden in der ausgewählten Sprache angezeigt wird.",
        "Nazwa powiadomienia": "Benachrichtigungsname",
        "Nazwa prezentowana klientom sklepu. Uzupełnij ją osobno dla każdego języka.": "Name, der den Shopkunden angezeigt wird. Füllen Sie ihn für jede Sprache separat aus.",
        "Nazwa prezentowana klientom. Uzupełnij ją osobno dla każdego języka.": "Name, der den Kunden angezeigt wird. Füllen Sie ihn für jede Sprache separat aus.",
        "Nazwa producenta": "Herstellername",
        "Nazwa producenta i jego widoczność w sklepie.": "Herstellername und Sichtbarkeit im Shop.",
        "Nazwa produktu": "Produktname",
        "Nazwa promocji": "Aktionsname",
        "Nazwa promocji wiązanej": "Name der Bundle-Aktion",
        "Nazwa przeceny": "Rabattname",
        "Nazwa sklepu": "Shopname",
        "Nazwa sposobu dostawy": "Name der Versandart",
        "Nazwa sposobu płatności": "Name der Zahlungsmethode",
        "Nazwa stawki i domyślna reguła dla produktów.": "Steuersatzname und Standardregel für Produkte.",
        "Nazwa systemowa": "Systemname",
        "Nazwa ułatwiająca rozpoznanie grupy cech w panelu.": "Name zur leichteren Identifizierung der Merkmalsgruppe im Panel.",
        "Nazwa ułatwiająca rozpoznanie metody dostawy w panelu.": "Name zur leichteren Identifizierung der Versandart im Panel.",
        "Nazwa ułatwiająca rozpoznanie wpisu w kalendarzu.": "Name zur leichteren Identifizierung des Kalendereintrags.",
        "Nazwa użytkownika": "Benutzername",
        "Nazwa używana do rozpoznania cechy w panelu administracyjnym.": "Name zur Identifizierung des Merkmals im Administrationsbereich.",
        "Nazwa widoczna na liście sklepów i w panelu administracyjnym.": "Name, der in der Shopliste und im Administrationsbereich angezeigt wird.",
        "Nazwa widoczna w sklepie": "Im Shop angezeigter Name",
        "Nazwa wpisu do kalendarza": "Name des Kalendereintrags",
        "Nazwa wyświetlana": "Angezeigter Name",
        "Nazwa, adres i treść kategorii.": "Name, Adresse und Inhalt der Kategorie.",
        "Nazwa, dostępność i treści prezentowane klientom sklepu.": "Name, Verfügbarkeit und Inhalte, die den Shopkunden angezeigt werden.",
        "Nazwa, identyfikator i waluta kraju.": "Name, ID und Währung des Landes.",
        "Nazwa, priorytet i okres wyświetlania etykiety.": "Name, Priorität und Anzeigezeitraum des Labels.",
        "Nazwa, sklep i zakres działania promocji.": "Name, Shop und Geltungsbereich der Aktion.",
        "Nazwa, widoczność i opis metody dostawy w sklepie.": "Name, Sichtbarkeit und Beschreibung der im Shop angezeigten Versandart.",
        "Nazwisko": "Nachname",
        "Nazwisko klienta": "Nachname des Kunden",
        "Nazwy": "Namen",
        "Nazwy i opis identyfikujący produkt w katalogu.": "Namen und Beschreibung zur Identifizierung des Produkts im Katalog.",
        "Nazwy, grupa i zasady uzupełniania cechy w produktach.": "Namen, Gruppe und Regeln zum Ergänzen des Merkmals bei Produkten.",
        "Netto": "Netto",
        "Nie": "Nein",
        "Nie dodano jeszcze żadnej cechy.": "Es wurde noch kein Merkmal hinzugefügt.",
        "Nie działa jedna z funkcji produktu": "Eine der Produktfunktionen funktioniert nicht",
        "Nie importuj": "Nicht importieren",
        "Nie pozwól": "Nicht zulassen",
        "Nie przypisano jeszcze żadnej kategorii.": "Es wurde noch keine Kategorie zugewiesen.",
        "Nie przypisano kolekcji.": "Es wurde keine Kollektion zugewiesen.",
        "Nie przypisano żadnej etykiety.": "Es wurde kein Label zugewiesen.",
        "Nie udało się odczytać pliku CSV.": "Die CSV-Datei konnte nicht gelesen werden.",
        "Nie udało się pobrać cech kategorii.": "Die Kategorienmerkmale konnten nicht abgerufen werden.",
        "Nie udało się pobrać listy kategorii.": "Die Kategorienliste konnte nicht abgerufen werden.",
        "Nie udało się pobrać reklamacji.": "Die Reklamationen konnten nicht abgerufen werden.",
        "Nie udało się przeszukać kategorii.": "Die Kategorien konnten nicht durchsucht werden.",
        "Nie udało się rozpocząć importu kategorii.": "Der Kategorienimport konnte nicht gestartet werden.",
        "Nie udało się rozpocząć importu produktów.": "Der Produktimport konnte nicht gestartet werden.",
        "Nie udało się skopiować danych do schowka.": "Die Daten konnten nicht in die Zwischenablage kopiert werden.",
        "Nie udało się wczytać cech produktu.": "Die Produktmerkmale konnten nicht geladen werden.",
        "Nie udało się wczytać cech.": "Die Merkmale konnten nicht geladen werden.",
        "Nie udało się wczytać cechy.": "Das Merkmal konnte nicht geladen werden.",
        "Nie udało się wczytać cennika.": "Die Preisliste konnte nicht geladen werden.",
        "Nie udało się wczytać części danych pomocniczych.": "Einige Hilfsdaten konnten nicht geladen werden.",
        "Nie udało się wczytać członków grupy.": "Die Gruppenmitglieder konnten nicht geladen werden.",
        "Nie udało się wczytać danych klienta.": "Die Kundendaten konnten nicht geladen werden.",
        "Nie udało się wczytać dostaw dla wybranego sklepu.": "Die Lieferungen für den ausgewählten Shop konnten nicht geladen werden.",
        "Nie udało się wczytać eksportu.": "Der Export konnte nicht geladen werden.",
        "Nie udało się wczytać etykiet.": "Die Labels konnten nicht geladen werden.",
        "Nie udało się wczytać faktur.": "Die Rechnungen konnten nicht geladen werden.",
        "Nie udało się wczytać faktury.": "Die Rechnung konnte nicht geladen werden.",
        "Nie udało się wczytać formularza. Spróbuj ponownie.": "Das Formular konnte nicht geladen werden. Versuchen Sie es erneut.",
        "Nie udało się wczytać grup cech.": "Die Merkmalsgruppen konnten nicht geladen werden.",
        "Nie udało się wczytać grup klientów.": "Die Kundengruppen konnten nicht geladen werden.",
        "Nie udało się wczytać grupy cech.": "Die Merkmalsgruppe konnte nicht geladen werden.",
        "Nie udało się wczytać grupy klientów.": "Die Kundengruppe konnte nicht geladen werden.",
        "Nie udało się wczytać historii cen.": "Der Preisverlauf konnte nicht geladen werden.",
        "Nie udało się wczytać historii wersji.": "Der Versionsverlauf konnte nicht geladen werden.",
        "Nie udało się wczytać katalogów.": "Die Kataloge konnten nicht geladen werden.",
        "Nie udało się wczytać kategorii.": "Die Kategorien konnten nicht geladen werden.",
        "Nie udało się wczytać klientów.": "Kunden konnten nicht geladen werden.",
        "Nie udało się wczytać kodów.": "Codes konnten nicht geladen werden.",
        "Nie udało się wczytać kolekcji.": "Sammlungen konnten nicht geladen werden.",
        "Nie udało się wczytać konfiguracji wariantów.": "Variantenkonfigurationen konnten nicht geladen werden.",
        "Nie udało się wczytać krajów.": "Länder konnten nicht geladen werden.",
        "Nie udało się wczytać listy.": "Liste konnte nicht geladen werden.",
        "Nie udało się wczytać nazw powiązanych elementów.": "Namen der verknüpften Elemente konnten nicht geladen werden.",
        "Nie udało się wczytać nazw produktów.": "Produktnamen konnten nicht geladen werden.",
        "Nie udało się wczytać notatek.": "Notizen konnten nicht geladen werden.",
        "Nie udało się wczytać opinii.": "Bewertungen konnten nicht geladen werden.",
        "Nie udało się wczytać podatków.": "Steuern konnten nicht geladen werden.",
        "Nie udało się wczytać pól źródła danych.": "Datenquellenfelder konnten nicht geladen werden.",
        "Nie udało się wczytać producentów.": "Hersteller konnten nicht geladen werden.",
        "Nie udało się wczytać produktów zestawu.": "Setprodukte konnten nicht geladen werden.",
        "Nie udało się wczytać produktów.": "Produkte konnten nicht geladen werden.",
        "Nie udało się wczytać produktu.": "Produkt konnte nicht geladen werden.",
        "Nie udało się wczytać promocji.": "Aktionen konnten nicht geladen werden.",
        "Nie udało się wczytać przypisanych cech.": "Zugewiesene Merkmale konnten nicht geladen werden.",
        "Nie udało się wczytać sklepów.": "Shops konnten nicht geladen werden.",
        "Nie udało się wczytać sklepu.": "Shop konnte nicht geladen werden.",
        "Nie udało się wczytać sposobów dostawy.": "Versandarten konnten nicht geladen werden.",
        "Nie udało się wczytać sposobów płatności.": "Zahlungsarten konnten nicht geladen werden.",
        "Nie udało się wczytać sposobu dostawy.": "Versandart konnte nicht geladen werden.",
        "Nie udało się wczytać sposobu płatności.": "Zahlungsart konnte nicht geladen werden.",
        "Nie udało się wczytać ustawień generowania kodów.": "Einstellungen für die Codegenerierung konnten nicht geladen werden.",
        "Nie udało się wczytać ustawień.": "Einstellungen konnten nicht geladen werden.",
        "Nie udało się wczytać walut.": "Währungen konnten nicht geladen werden.",
        "Nie udało się wczytać wariantów.": "Varianten konnten nicht geladen werden.",
        "Nie udało się wczytać wartości cechy.": "Merkmalswert konnte nicht geladen werden.",
        "Nie udało się wczytać zamówień.": "Bestellungen konnten nicht geladen werden.",
        "Nie udało się wczytać zamówienia.": "Bestellung konnte nicht geladen werden.",
        "Nie udało się wczytać zgłoszenia.": "Anfrage konnte nicht geladen werden.",
        "Nie udało się wczytać zwrotów.": "Rücksendungen konnten nicht geladen werden.",
        "Nie udało się zapisać kolejności. Spróbuj ponownie.": "Reihenfolge konnte nicht gespeichert werden. Versuchen Sie es erneut.",
        "Nie uwzględniaj dla produktów z dostawą na palecie": "Nicht für Produkte mit Palettenversand berücksichtigen",
        "Nie uzupełniono": "Nicht ausgefüllt",
        "Nie wybrano pliku": "Keine Datei ausgewählt",
        "Nie wybrano żadnej opinii.": "Keine Bewertung ausgewählt.",
        "Nie wybrano żadnych etykiet.": "Keine Etiketten ausgewählt.",
        "Nie zawiera": "Enthält nicht",
        "Nie znaleziono wybranego produktu.": "Das ausgewählte Produkt wurde nicht gefunden.",
        "Nieaktywna": "Inaktiv",
        "Nieaktywna kolekcja nie jest widoczna w sklepie.": "Eine inaktive Sammlung ist im Shop nicht sichtbar.",
        "Nieaktywne": "Inaktiv",
        "Niekompletny zestaw / brak akcesoriów": "Unvollständiges Set / Zubehör fehlt",
        "Niektóre wersje językowe zostały już przypisane do innych sklepów.": "Einige Sprachversionen wurden bereits anderen Shops zugewiesen.",
        "Nielimitowana": "Unbegrenzt",
        "Niestandardowa wiadomość": "Benutzerdefinierte Nachricht",
        "NIP": "USt-IdNr.",
        "Notatka": "Notiz",
        "Notatka administracyjna": "Administrative Notiz",
        "Notatka administracyjna została zapisana.": "Die administrative Notiz wurde gespeichert.",
        "Notatka została usunięta.": "Die Notiz wurde gelöscht.",
        "Notatka została zapisana.": "Die Notiz wurde gespeichert.",
        "Notatki": "Notizen",
        "Nowa cecha": "Neues Merkmal",
        "Nowa etykieta": "Neues Etikett",
        "Nowa faktura": "Neue Rechnung",
        "Nowa grupa cech": "Neue Merkmalsgruppe",
        "Nowa grupa klientów": "Neue Kundengruppe",
        "Nowa kolekcja": "Neue Sammlung",
        "Nowa opcja dostawy": "Neue Versandoption",
        "Nowa promocja wiązana": "Neue Bundle-Aktion",
        "Nowa przecena": "Neuer Sonderpreis",
        "Nowa stawka podatku": "Neuer Steuersatz",
        "Nowa waluta": "Neue Währung",
        "Nowe": "Neu",
        "Nowe powiadomienie": "Neue Benachrichtigung",
        "Nowe warianty": "Neue Varianten",
        "Nowe zgłoszenie": "Neue Anfrage",
        "Nowy eksport": "Neuer Export",
        "Nowy kod rabatowy": "Neuer Rabattcode",
        "Nowy kraj": "Neues Land",
        "Nowy parametr UTM": "Neuer UTM-Parameter",
        "Nowy producent": "Neuer Hersteller",
        "Nowy produkt": "Neues Produkt",
        "Nowy sklep": "Neuer Shop",
        "Nowy sposób płatności": "Neue Zahlungsart",
        "Nowy wpis w kalendarzu": "Neuer Kalendereintrag",
        "np. Apple A19 Pro": "z. B. Apple A19 Pro",
        "np. Podzespoły": "z. B. Komponenten",
        "np. Procesor": "z. B. Prozessor",
        "np. Sklep główny": "z. B. Hauptshop",
        "Numer": "Nummer",
        "Numer budynku": "Gebäudenummer",
        "Numer domu / mieszkania": "Hausnummer / Wohnungsnummer",
        "Numer faktury": "Rechnungsnummer",
        "Numer kierunkowy": "Vorwahl",
        "Numer konta": "Kontonummer",
        "Numer reklamacji": "Reklamationsnummer",
        "Numer zamówienia": "Bestellnummer",
        "Numer zgłoszenia": "Anfragenummer",
        "Numer zwrotu": "Rücksendenummer",
        "Obiekt": "Objekt",
        "Ocena": "Bewertung",
        "Ocena do": "Bewertung bis",
        "Ocena od": "Bewertung ab",
        "Oceniony produkt": "Bewertetes Produkt",
        "Oczekujące": "Ausstehend",
        "Oczekujący na publikację": "Wartet auf Veröffentlichung",
        "Oczekuje na płatność": "Wartet auf Zahlung",
        "Oczekuje na wysłanie": "Wartet auf Versand",
        "Odbiór osobisty": "Selbstabholung",
        "Odbiorca": "Empfänger",
        "Odbiorca (firma)": "Empfänger (Unternehmen)",
        "Oddziel kolejne wartości przecinkami.": "Trennen Sie die folgenden Werte durch Kommas.",
        "Odpiąć cechę od grupy? Cecha pozostanie w katalogu.": "Merkmal von der Gruppe lösen? Das Merkmal bleibt im Katalog erhalten.",
        "Odrzucone": "Abgelehnt",
        "Odrzucony": "Abgelehnt",
        "Odstęp góra i dół": "Abstand oben und unten",
        "Odstęp lewa i prawa": "Abstand links und rechts",
        "Odstępy i obramowanie": "Abstände und Rahmen",
        "Ogólne": "Allgemein",
        "Okres działania i powtarzające się przedziały godzinowe.": "Gültigkeitszeitraum und wiederkehrende Zeitintervalle.",
        "Okres przechowywania historii przeglądanych produktów.": "Aufbewahrungsdauer des Verlaufs der angesehenen Produkte.",
        "Określ czas przechowywania nieaktywnych koszyków.": "Legen Sie fest, wie lange inaktive Warenkörbe gespeichert werden.",
        "Określ ilość produktu pozostawianą w magazynie.": "Legen Sie die Produktmenge fest, die auf Lager bleiben soll.",
        "Określ miejsce kategorii w katalogu.": "Legen Sie die Position der Kategorie im Katalog fest.",
        "Określ terminy dostępności formularzy zgłoszeń po zrealizowaniu zamówienia.": "Legen Sie fest, wann Anfrageformulare nach Abschluss einer Bestellung verfügbar sind.",
        "Określ zasady zamawiania dla niezalogowanych klientów i produktów bez dostępnego zapasu.": "Legen Sie die Bestellregeln für nicht angemeldete Kunden und Produkte ohne verfügbaren Lagerbestand fest.",
        "Określa, czy klient może zamówić produkt mimo braku dostępnego zapasu.": "Legt fest, ob der Kunde ein Produkt trotz fehlenden Lagerbestands bestellen kann.",
        "Opcja przeliczenia": "Umrechnungsoption",
        "Opcje dokumentu": "Dokumentoptionen",
        "Opcje elementu": "Elementoptionen",
        "Opcjonalna grafika reprezentująca wartość tekstową cechy. Wybierz jeden plik.": "Optionale Grafik zur Darstellung des Textwerts eines Merkmals. Wählen Sie eine Datei aus.",
        "Operacja spowoduje trwałe usunięcie wszystkich kategorii należących do tego katalogu! Czy na pewno chcesz wykonać akcję?": "Dieser Vorgang löscht dauerhaft alle Kategorien, die zu diesem Katalog gehören! Möchten Sie die Aktion wirklich ausführen?",
        "Operator": "Operator",
        "Operator lub moduł obsługujący tę metodę dostawy.": "Operator oder Modul, das diese Versandart abwickelt.",
        "Opinia": "Bewertung",
        "Opinia została usunięta.": "Die Bewertung wurde gelöscht.",
        "Opinia została zaktualizowana.": "Die Bewertung wurde aktualisiert.",
        "Opinie": "Bewertungen",
        "Opinie produktowe": "Produktbewertungen",
        "Opinie zostały zaktualizowane": "Die Bewertungen wurden aktualisiert",
        "Ogranicz produkty uwzględnione w feedzie.": "Produkte im Feed eingrenzen.",
        "Opinii na stronie": "Bewertungen pro Seite",
        "Opis": "Beschreibung",
        "Opis grupy": "Gruppenbeschreibung",
        "Opis produktu": "Produktbeschreibung",
        "Opis wady": "Beschreibung des Mangels",
        "Opis wartości": "Wertbeschreibung",
        "Opis został wygenerowany": "Die Beschreibung wurde generiert",
        "Opisy": "Beschreibungen",
        "Opisy prezentowane w sklepie w poszczególnych językach.": "Beschreibungen, die im Shop in den jeweiligen Sprachen angezeigt werden.",
        "Opisz, jakich klientów obejmuje grupa i do czego służy.": "Beschreiben Sie, welche Kunden zur Gruppe gehören und wozu sie dient.",
        "Opłacona": "Bezahlt",
        "Opłacone": "Bezahlt",
        "Opłacono": "Bezahlt",
        "Opublikowany": "Veröffentlicht",
        "Oraz (and)": "Und (and)",
        "Osoba fizyczna": "Privatperson",
        "Ostatni miesiąc": "Letzter Monat",
        "Ostatni rok": "Letztes Jahr",
        "Ostatnia aktualizacja:": "Letzte Aktualisierung:",
        "Ostatnia modyfikacja": "Letzte Änderung",
        "Ostatnie 24h": "Letzte 24 Stunden",
        "Ostatnie 7 dni": "Letzte 7 Tage",
        "Ostatnie 90 dni": "Letzte 90 Tage",
        "Ostrzeżenie": "Warnung",
        "Otrzymałem(-am) inny produkt niż zamówiony": "Ich habe ein anderes Produkt als das bestellte erhalten",
        "Otrzymałem(-am) niewłaściwy produkt": "Ich habe das falsche Produkt erhalten",
        "Oznaczenie metody dostawy i powiązane formy płatności.": "Bezeichnung der Versandart und zugehörige Zahlungsarten.",
        "Oznaczenie wyświetlane przy kwotach, np. zł lub €.": "Bezeichnung, die neben Beträgen angezeigt wird, z. B. zł oder €.",
        "Parametr UTM": "UTM-Parameter",
        "Parametr UTM został dodany.": "Der UTM-Parameter wurde hinzugefügt.",
        "Parametr UTM został zaktualizowany.": "Der UTM-Parameter wurde aktualisiert.",
        "Parametr został usunięty.": "Der Parameter wurde gelöscht.",
        "Parametry logistyczne": "Logistikparameter",
        "Parametry przesyłki używane podczas realizacji zamówienia.": "Versandparameter, die bei der Auftragsabwicklung verwendet werden.",
        "Parametry UTM": "UTM-Parameter",
        "PayPal": "PayPal",
        "PayU": "PayU",
        "Pełna treść strony produktu w poszczególnych językach.": "Vollständiger Inhalt der Produktseite in den jeweiligen Sprachen.",
        "Pierwszy wiersz jest nagłówkiem": "Die erste Zeile ist eine Kopfzeile",
        "PIN": "PIN",
        "Planowana data publikacji": "Geplantes Veröffentlichungsdatum",
        "Płatność": "Zahlung",
        "Płatność przy odbiorze": "Zahlung bei Abholung",
        "płatność wyłączona": "Zahlung deaktiviert",
        "Płatność za pobraniem": "Nachnahme",
        "Płatności": "Zahlungen",
        "Plik CSV": "CSV-Datei",
        "Plik CSV nie zawiera danych.": "Die CSV-Datei enthält keine Daten.",
        "Plik faktury": "Rechnungsdatei",
        "Pliki udostępniane z kolekcją.": "Dateien, die mit einer Kollektion geteilt werden.",
        "Po tym czasie nieaktywny koszyk zostanie usunięty.": "Nach diesem Zeitraum wird der inaktive Warenkorb gelöscht.",
        "Po wyłączeniu każda nowa opinia wymaga ręcznego zatwierdzenia.": "Wenn diese Option deaktiviert ist, muss jede neue Bewertung manuell freigegeben werden.",
        "Po zapisaniu promocji nie można zmienić efektów.": "Nach dem Speichern der Promotion können die Effekte nicht mehr geändert werden.",
        "Po zapisaniu promocji nie można zmienić efektu.": "Nach dem Speichern der Promotion kann der Effekt nicht mehr geändert werden.",
        "Po zapisaniu promocji nie można zmienić sklepu.": "Nach dem Speichern der Promotion kann der Shop nicht mehr geändert werden.",
        "Po zapisaniu promocji nie można zmienić typu kodu.": "Nach dem Speichern der Promotion kann der Gutscheincode-Typ nicht mehr geändert werden.",
        "Po zmianie stawki podatku możesz przeliczyć ceny produktów, zachowując przy tym cenę netto lub brutto. Zachowanie ceny netto przelicza cenę brutto, a zachowanie ceny brutto przelicza cenę netto zgodnie z nową wartością przypisanego podatku.": "Nach einer Änderung des Steuersatzes können Sie die Produktpreise neu berechnen und dabei den Netto- oder Bruttopreis beibehalten. Wird der Nettopreis beibehalten, wird der Bruttopreis neu berechnet; wird der Bruttopreis beibehalten, wird der Nettopreis anhand des neuen zugewiesenen Steuersatzes neu berechnet.",
        "Pobiera koszyki według obecności adresu email i czasu od porzucenia. Możesz wybrać kilka okresów jednocześnie.": "Ruft Warenkörbe anhand des Vorhandenseins einer E-Mail-Adresse und der Zeit seit dem Abbruch ab. Sie können mehrere Zeiträume gleichzeitig auswählen.",
        "Pobierz etykietę": "Etikett herunterladen",
        "Pobierz etykiety": "Etiketten herunterladen",
        "Pobranie": "Abholung",
        "Pobranie kodu promocyjnego": "Gutscheincode abrufen",
        "Pobranie koszyków": "Warenkörbe abrufen",
        "Pochylenie": "Neigung",
        "Podatek": "Steuer",
        "Podatki": "Steuern",
        "Podatki zostały zaktualizowane": "Die Steuern wurden aktualisiert",
        "Podgląd": "Vorschau",
        "Podgląd kategorii": "Kategorie-Vorschau",
        "Podgląd kodu": "Codevorschau",
        "Podgląd na jasnym i ciemnym tle sklepu.": "Vorschau auf hellem und dunklem Shop-Hintergrund.",
        "Podgląd zdjęcia produktu": "Produktbildvorschau",
        "Podkreślenie": "Unterstreichung",
        "Podstawowe informacje": "Grundlegende Informationen",
        "Podstawowe informacje o złożonym zamówieniu.": "Grundlegende Informationen zur aufgegebenen Bestellung.",
        "Podsumowanie": "Zusammenfassung",
        "Podsumowanie opinii": "Bewertungsübersicht",
        "Podsumowanie opinii klientów (AI)": "Zusammenfassung der Kundenbewertungen (KI)",
        "Pogrubienie": "Fettdruck",
        "Pokaż atrybut": "Attribut anzeigen",
        "Pokaż kafelki do ostatniego poziomu": "Kacheln bis zur letzten Ebene anzeigen",
        "Pokaż kafelki do wybranego poziomu": "Kacheln bis zur ausgewählten Ebene anzeigen",
        "Pola z wybranego formularza pojawią się w zgłoszeniu reklamacyjnym.": "Die Felder aus dem ausgewählten Formular werden in der Reklamation angezeigt.",
        "Pole \"Liczba wyników\" jest wymagane.": "Das Feld \"Anzahl der Ergebnisse\" ist erforderlich.",
        "Pole \"Promocja\" jest wymagane.": "Das Feld \"Aktion\" ist erforderlich.",
        "Pole \"Sklep\" jest wymagane.": "Das Feld \"Shop\" ist erforderlich.",
        "Pole \"Sposób prezentacji wartości\" jest wymagane.": "Das Feld \"Darstellung der Werte\" ist erforderlich.",
        "Pole \"Tryb wyświetlania\" jest wymagane.": "Das Feld \"Anzeigemodus\" ist erforderlich.",
        "Pole \"Typ\" jest wymagane.": "Das Feld \"Typ\" ist erforderlich.",
        "Pole \"Witryna\" jest wymagane.": "Das Feld \"Website\" ist erforderlich.",
        "Pole dziedziczone z produktu bazowego.": "Vom Basisprodukt geerbtes Feld.",
        "Pole z modelu": "Feld aus dem Modell",
        "Pomyłka przy zakupie": "Fehlkauf",
        "Poprzedni okres": "Vorheriger Zeitraum",
        "Porzucone koszyki": "Verlassene Warenkörbe",
        "Posiada wagę": "Hat ein Gewicht",
        "Posiada zdjęcie": "Hat ein Bild",
        "Potwierdzenie dezaktywacji": "Bestätigung der Deaktivierung",
        "Potwierdzenie kopiowania": "Bestätigung des Kopiervorgangs",
        "Potwierdzenie usunięcia": "Bestätigung der Löschung",
        "Potwierdzenie usunięcia. Wykonanie tej akcji nie usunie cechy przypisanej do produktów.": "Bestätigung der Löschung. Durch Ausführen dieser Aktion wird das den Produkten zugewiesene Merkmal nicht gelöscht.",
        "Powiadomienia": "Benachrichtigungen",
        "Powiadomienie": "Benachrichtigung",
        "Powiadomienie do zamówienia": "Benachrichtigung zur Bestellung",
        "Powiadomienie zostało dodane.": "Die Benachrichtigung wurde hinzugefügt.",
        "Powiadomienie zostało usunięte.": "Die Benachrichtigung wurde gelöscht.",
        "Powiadomienie zostało zaktualizowane.": "Die Benachrichtigung wurde aktualisiert.",
        "Powód": "Grund",
        "Powód dezaktywacji": "Grund der Deaktivierung",
        "Powód dezaktywacji ceny": "Grund für die Preisdeaktivierung",
        "Powód reklamacji": "Reklamationsgrund",
        "Poziom kategorii": "Kategorieebene",
        "Pozostałe parametry": "Weitere Parameter",
        "Pozostałe zdjęcia": "Weitere Bilder",
        "Pozostało do zapłaty": "Noch zu zahlen",
        "Pozostało do zapłaty: {amount}": "Noch zu zahlen: {amount}",
        "Pozwól": "Erlauben",
        "Pozycje zamówienia i ich wartości.": "Bestellpositionen und ihre Werte.",
        "Pozytywna": "Positiv",
        "Prawda": "Wahr",
        "Prawda/Fałsz": "Wahr/Falsch",
        "Priorytet": "Priorität",
        "Procentowy": "Prozentual",
        "Producenci": "Hersteller",
        "Producent": "Hersteller",
        "Producent aktywny": "Hersteller aktiv",
        "Producent został dodany.": "Der Hersteller wurde hinzugefügt.",
        "Producent został usunięty.": "Der Hersteller wurde gelöscht.",
        "Producent został zaktualizowany.": "Der Hersteller wurde aktualisiert.",
        "Produkt": "Produkt",
        "Produkt bazowy": "Basisprodukt",
        "Produkt dodawany jako gratis po spełnieniu progu.": "Produkt, das nach Erreichen des Schwellenwerts gratis hinzugefügt wird.",
        "Produkt dodawany jako gratis.": "Produkt, das gratis hinzugefügt wird.",
        "Produkt dotarł uszkodzony": "Produkt beschädigt angekommen",
        "Produkt dotarł za późno": "Produkt zu spät angekommen",
        "Produkt jest niezgodny z opisem": "Produkt entspricht nicht der Beschreibung",
        "Produkt ma wadę fabryczną": "Produkt hat einen Herstellungsfehler",
        "Produkt nie działa / działa nieprawidłowo": "Produkt funktioniert nicht / funktioniert nicht richtig",
        "Produkt nie spełnia oczekiwań": "Produkt entspricht nicht den Erwartungen",
        "Produkt nosi ślady użytkowania": "Produkt weist Gebrauchsspuren auf",
        "Produkt o statusie Oczekujący na publikację zostanie opublikowany po tej dacie.": "Das Produkt mit dem Status „Veröffentlichung ausstehend“ wird nach diesem Datum veröffentlicht.",
        "Produkt posiada warianty": "Produkt hat Varianten",
        "Produkt rekomendowany": "Empfohlenes Produkt",
        "Produkt uszkodzony po dostawie": "Produkt nach der Lieferung beschädigt",
        "Produkt wygląda inaczej niż na zdjęciach": "Produkt sieht anders aus als auf den Fotos",
        "Produkt wymaga transportu na palecie.": "Das Produkt muss auf einer Palette transportiert werden.",
        "Produkt został dodany.": "Das Produkt wurde hinzugefügt.",
        "Produkt został skopiowany.": "Das Produkt wurde kopiert.",
        "Produkt został usunięty.": "Das Produkt wurde gelöscht.",
        "Produkt został zaktualizowany.": "Das Produkt wurde aktualisiert.",
        "Produkty": "Produkte",
        "Produkty komplementarne": "Ergänzende Produkte",
        "Produkty objęte indywidualnymi kodami.": "Produkte mit individuellen Codes.",
        "Produkty otagowane": "Getaggte Produkte",
        "Produkty polecane razem z aktualnym produktem.": "Produkte, die zusammen mit dem aktuellen Produkt empfohlen werden.",
        "Produkty rekomendowane": "Empfohlene Produkte",
        "Produkty uwzględnione": "Berücksichtigte Produkte",
        "Produkty uwzględnione w promocji": "In der Aktion berücksichtigte Produkte",
        "Produkty uzupełniające ofertę aktualnego produktu.": "Produkte, die das Angebot des aktuellen Produkts ergänzen.",
        "Produkty w kolekcji": "Produkte in der Kollektion",
        "Produkty w promocji": "Aktionsprodukte",
        "Produkty wraz z wariantami": "Produkte einschließlich Varianten",
        "Produkty zostały usunięte z systemu": "Die Produkte wurden aus dem System gelöscht",
        "Produkty zostały zaktualizowane": "Die Produkte wurden aktualisiert",
        "Próg ilościowy": "Mengenschwelle",
        "Promocja": "Aktion",
        "Promocja jest w trakcie działania. Możesz zmienić jej nazwę i aktywność; pozostałe parametry są zablokowane.": "Die Aktion läuft gerade. Sie können ihren Namen und ihren Status ändern; die übrigen Parameter sind gesperrt.",
        "Promocja obowiązuje tylko w wybranych godzinach każdego dnia.": "Die Aktion gilt täglich nur während der ausgewählten Stunden.",
        "Promocja wiązana": "Verbundaktion",
        "Promocja wiązana została usunięta.": "Die Verbundaktion wurde gelöscht.",
        "Promocja włączona": "Aktion aktiviert",
        "Promocja została dodana.": "Die Aktion wurde hinzugefügt.",
        "Promocja została usunięta.": "Die Aktion wurde gelöscht.",
        "Promocja została zaktualizowana.": "Die Aktion wurde aktualisiert.",
        "Promocje": "Aktionen",
        "Promocje wiązana": "Verbundaktion",
        "Promocje wiązane": "Verbundaktionen",
        "Protokół OAuth - client_id": "OAuth-Protokoll – client_id",
        "Protokół OAuth - client_secret": "OAuth-Protokoll – client_secret",
        "Przecena produktów": "Produktpreisnachlass",
        "Przecena zamówienia": "Bestellpreisnachlass",
        "Przeceny": "Preisnachlässe",
        "Przeceny produktów": "Produktpreisnachlässe",
        "Przeciągnij cechy, aby ustalić kolejność ich wyświetlania.": "Ziehen Sie die Merkmale, um ihre Anzeigereihenfolge festzulegen.",
        "Przeciągnij grupy cech, aby ustalić kolejność ich wyświetlania.": "Ziehen Sie die Merkmalgruppen, um ihre Anzeigereihenfolge festzulegen.",
        "Przeciągnij uchwyt, aby zmienić kolejność. Możesz też użyć klawiatury: Spacja, strzałki i Enter.": "Ziehen Sie den Ziehgriff, um die Reihenfolge zu ändern. Sie können auch die Tastatur verwenden: Leertaste, Pfeiltasten und Eingabetaste.",
        "Przeciągnij wartości, aby ustalić kolejność ich wyświetlania.": "Ziehen Sie die Werte, um ihre Anzeigereihenfolge festzulegen.",
        "Przedrostek": "Präfix",
        "Przekreślenie": "Durchgestrichen",
        "Przelew tradycyjny": "Banküberweisung",
        "Przelewy24": "Przelewy24",
        "Przelicz": "Berechnen",
        "Przelicz podatek": "Steuer berechnen",
        "Przelicz podatki": "Steuern berechnen",
        "Przenieś wartość {name}": "Wert {name} verschieben",
        "Przewidywany czas realizacji dostawy.": "Voraussichtliche Lieferzeit.",
        "Przypisane kategorie": "Zugewiesene Kategorien",
        "Przypisany": "Zugewiesen",
        "Przypisuj użytkowników do grupy i zarządzaj jej członkami.": "Weisen Sie Benutzer der Gruppe zu und verwalten Sie ihre Mitglieder.",
        "Przypisz cechę do grupy, aby uporządkować parametry produktów.": "Weisen Sie der Gruppe ein Merkmal zu, um die Produktparameter zu ordnen.",
        "Przypisz cechy produktów i sprawdź cechy odziedziczone.": "Weisen Sie Produktmerkmale zu und prüfen Sie geerbte Merkmale.",
        "Przypisz cechy, które mają należeć do tej grupy.": "Weisen Sie die Merkmale zu, die zu dieser Gruppe gehören sollen.",
        "Przypisz sklep do wersji językowych witryn.": "Weisen Sie den Sprachversionen der Websites einen Shop zu.",
        "Przyrostek": "Suffix",
        "Publikacja": "Veröffentlichung",
        "Publikuj do": "Veröffentlichen bis",
        "Publikuj od": "Veröffentlichen ab",
        "Rabat": "Rabatt",
        "Rabaty": "Rabatte",
        "Reguła podatkowa stosowana do kosztu dostawy.": "Steuerregel für die Versandkosten.",
        "Reguła podatku": "Steuerregel",
        "Reklamacja": "Reklamation",
        "Reklamacje": "Reklamationen",
        "reklamacje / zamówienia": "Reklamationen / Bestellungen",
        "Reklamacje i zwroty": "Reklamationen und Rücksendungen",
        "Rekomendacja": "Empfehlung",
        "Rezerwacja stanów magazynowych": "Lagerbestände reservieren",
        "Rezerwacje magazynowe": "Lagerreservierungen",
        "Rodzaj kodu": "Codeart",
        "Rodzaj płatności": "Zahlungsart",
        "Równe": "Gleich",
        "Rozliczenie": "Abrechnung",
        "Rozliczenie faktury": "Rechnungsabrechnung",
        "Rozliczenie powiązanego zamówienia.": "Abrechnung der zugehörigen Bestellung.",
        "Rozmiar i waga paczki": "Größe und Gewicht des Pakets",
        "Rozmiar nie pasuje": "Größe passt nicht",
        "Rozmiar, styl i dekoracje tekstu.": "Größe, Stil und Textdekoration.",
        "Różne": "Sonstiges",
        "Rozpoczęto checkout": "Checkout gestartet",
        "Ścieżki": "Pfade",
        "Secret ID": "Secret ID",
        "Sesje": "Sitzungen",
        "Siatka": "Raster",
        "Sklep": "Shop",
        "Sklep został dodany.": "Der Shop wurde hinzugefügt.",
        "Sklep został usunięty.": "Der Shop wurde gelöscht.",
        "Sklep został zaktualizowany.": "Der Shop wurde aktualisiert.",
        "Sklepy": "Shops",
        "Skonfiguruj zawartość": "Inhalt konfigurieren",
        "Skopiowano": "Kopiert",
        "Skopiowano do schowka.": "In die Zwischenablage kopiert.",
        "SKU": "SKU",
        "Slider": "Slider",
        "Słowa kluczowe": "Schlüsselwörter",
        "Słowa opisujące kategorię. Możesz oddzielić je przecinkami.": "Wörter, die die Kategorie beschreiben. Sie können sie durch Kommas trennen.",
        "Sortowanie cech": "Merkmale sortieren",
        "Sortowanie grup cech": "Merkmalgruppen sortieren",
        "Sortowanie wartości": "Werte sortieren",
        "Sortowanie wartości cechy": "Merkmalwerte sortieren",
        "Sortuj": "Sortieren",
        "Sortuj cechy": "Merkmale sortieren",
        "Sortuj grupy cech": "Merkmalgruppen sortieren",
        "Sposób dostawy": "Versandart",
        "Sposób dostawy włączony": "Versandart aktiviert",
        "Sposób dostawy został dodany.": "Die Versandart wurde hinzugefügt.",
        "Sposób dostawy został usunięty.": "Die Versandart wurde gelöscht.",
        "Sposób dostawy został zaktualizowany.": "Die Versandart wurde aktualisiert.",
        "Sposób łączenia warunków": "Verknüpfungsart der Bedingungen",
        "Sposób płatności": "Zahlungsart",
        "Sposób płatności włączony": "Zahlungsart aktiviert",
        "Sposób płatności został dodany.": "Die Zahlungsart wurde hinzugefügt.",
        "Sposób płatności został usunięty.": "Die Zahlungsart wurde gelöscht.",
        "Sposób płatności został zaktualizowany.": "Die Zahlungsart wurde aktualisiert.",
        "Sposób prezentacji cen": "Preisdarstellung",
        "Sposób prezentacji wartości": "Wertdarstellung",
        "Sposób przekazania przesyłki klientowi.": "Art der Übergabe der Sendung an den Kunden.",
        "Sposób wyświetlania": "Darstellungsweise",
        "Sposób wyświetlania kafelków kategorii": "Darstellungsweise der Kategorie-Kacheln",
        "Spróbuj ponownie": "Erneut versuchen",
        "Sprzedaż": "Umsatz",
        "Sprzedaż brutto": "Bruttoumsatz",
        "Sprzedaż całkowita": "Gesamtumsatz",
        "Sprzedaż netto": "Nettoumsatz",
        "Średnia": "Durchschnitt",
        "Środowisko": "Umgebung",
        "Środowisko testowe lub produkcyjne integracji.": "Test- oder Produktionsumgebung der Integration.",
        "Stały": "Fest",
        "Stan magazynowy": "Lagerbestand",
        "Stan magazynu": "Lagerbestand",
        "Standalone": "Eigenständig",
        "Standardowy": "Standard",
        "Status": "Status",
        "Status (Draft, WaitingForPublication, Published)": "Status (Draft, WaitingForPublication, Published)",
        "Status dostawy": "Lieferstatus",
        "Status faktury": "Rechnungsstatus",
        "Status i wartość zamówienia.": "Status und Wert der Bestellung.",
        "Status koszyka": "Warenkorbstatus",
        "Status kupującego": "Käuferstatus",
        "Status opinii": "Bewertungsstatus",
        "Status płatności": "Zahlungsstatus",
        "Status reklamacji został zmieniony.": "Der Reklamationsstatus wurde geändert.",
        "Status zamówienia": "Bestellstatus",
        "Status zwrotu został zmieniony.": "Der Rückgabestatus wurde geändert.",
        "Stawka domyślna": "Standardsatz",
        "Stawka podatku": "Steuersatz",
        "Stawka została dodana.": "Der Steuersatz wurde hinzugefügt.",
        "Stawka została usunięta.": "Der Steuersatz wurde gelöscht.",
        "Stawka została zaktualizowana.": "Der Steuersatz wurde aktualisiert.",
        "Stawki podatkowe obowiązujące w wybranym kraju.": "Im ausgewählten Land geltende Steuersätze.",
        "Stawki podatku w poszczególnych państwach": "Steuersätze in den einzelnen Ländern",
        "Stosowana dla produktów bez własnej reguły podatku.": "Wird auf Produkte ohne eigene Steuerregel angewendet.",
        "Strefa czasowa": "Zeitzone",
        "Strefa czasowa używana przez sklep przy obsłudze dat i godzin.": "Vom Shop für die Verarbeitung von Datum und Uhrzeit verwendete Zeitzone.",
        "Strona producenta": "Herstellerseite",
        "Struktura dokumentu": "Dokumentstruktur",
        "Styl dekoracji tekstu": "Textdekorationsstil",
        "Styl obramowania": "Rahmenstil",
        "Sugerowane ceny": "Preisempfehlungen",
        "Suma cen produktów od której naliczany jest rabat (brutto)": "Gesamtpreis der Produkte, ab dem der Rabatt berechnet wird (brutto)",
        "Symbol": "Symbol",
        "Symbol identyfikujący ten zakres cen dostawy.": "Symbol zur Identifizierung dieses Lieferpreisbereichs.",
        "Symbol kategorii": "Kategoriesymbol",
        "Symbol kolekcji": "Sammlungssymbol",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku -.": "Das Symbol darf nur aus Kleinbuchstaben, Ziffern und dem Zeichen - bestehen.",
        "Symbol może składać się z małych liter, cyfr oraz znaku -.": "Das Symbol darf aus Kleinbuchstaben, Ziffern und dem Zeichen - bestehen.",
        "Symbol może zawierać małe litery, cyfry i znak -.": "Das Symbol darf Kleinbuchstaben, Ziffern und das Zeichen - enthalten.",
        "Symbol produktu": "Produktsymbol",
        "Synchronizuj": "Synchronisieren",
        "System opinii": "Bewertungssystem",
        "System opinii włączony": "Bewertungssystem aktiviert",
        "Szablon": "Vorlage",
        "Szczegółowe informacje o producencie w poszczególnych językach.": "Detaillierte Herstellerinformationen in den einzelnen Sprachen.",
        "Szczegóły faktury": "Rechnungsdetails",
        "Szczegóły klienta": "Kundendetails",
        "Szczegóły kolekcji": "Sammlungsdetails",
        "Szczegóły opinii": "Bewertungsdetails",
        "Szczegóły reklamacji": "Reklamationsdetails",
        "Szczegóły zamówienia": "Bestelldetails",
        "Szczegóły zgłoszenia": "Ticketdetails",
        "Szczegóły zwrotu": "Rückgabedetails",
        "Szerokość": "Breite",
        "Szerokość paczki": "Paketbreite",
        "Szkic": "Entwurf",
        "szt": "Stk.",
        "szt.": "Stk.",
        "Szukaj kategorii": "Kategorien suchen",
        "Szukaj kategorii…": "Kategorien suchen…",
        "Ta forma dostawy jest wyłączona": "Diese Versandart ist deaktiviert",
        "Tabela": "Tabelle",
        "Tak": "Ja",
        "Tekst": "Text",
        "Tekst wyświetlany podczas ustawienia blokady": "Text, der während der Sperre angezeigt wird",
        "Telefon": "Telefon",
        "Temat": "Betreff",
        "Ten moduł nie wymaga dodatkowej konfiguracji webservice.": "Dieses Modul erfordert keine zusätzliche Webservice-Konfiguration.",
        "Token API ShipX": "ShipX-API-Token",
        "Token dostępu do API obsługującego przesyłki InPost.": "Zugriffstoken für die API zur Abwicklung von InPost-Sendungen.",
        "Token Geowidget": "Geowidget-Token",
        "Token mapy punktów odbioru InPost.": "Token für die Karte der InPost-Abholpunkte.",
        "tPay": "tPay",
        "Treść": "Inhalt",
        "Treść notatki": "Notizinhalt",
        "Treść opinii": "Bewertungstext",
        "Treść prezentowana klientom sklepu.": "Inhalt, der den Kunden des Shops angezeigt wird.",
        "Trwa generowanie opisu": "Beschreibung wird generiert",
        "Tryb wyświetlania": "Anzeigemodus",
        "Trzyliterowy kod waluty, np. PLN lub EUR.": "Dreistelliger Währungscode, z. B. PLN oder EUR.",
        "Tworzenie cennika": "Preisliste erstellen",
        "Tworzenie faktury": "Rechnung erstellen",
        "Tworzenie wariantów": "Varianten erstellen",
        "Typ": "Typ",
        "Typ (Standard, Pack)": "Typ (Standard, Pack)",
        "Typ danych": "Datentyp",
        "Typ danych listy": "Listendatentyp",
        "Typ dostawy": "Lieferart",
        "Typ elementu": "Elementtyp",
        "Typ kodu i ograniczenia jego wykorzystania.": "Code-Typ und Einschränkungen seiner Verwendung.",
        "Typ notatki": "Notiztyp",
        "Typ parametru UTM": "UTM-Parametertyp",
        "Typ produktu i jego dostępność na stronie.": "Produkttyp und seine Verfügbarkeit im Shop.",
        "Typ rabatu": "Rabattart",
        "Typ widgetu": "Widget-Typ",
        "Typografia": "Typografie",
        "Typu nie można zmienić po utworzeniu.": "Der Typ kann nach der Erstellung nicht geändert werden.",
        "Udział procentowy": "Prozentualer Anteil",
        "Ukryj atrybut": "Attribut ausblenden",
        "Ukryj kafelki": "Kacheln ausblenden",
        "Ukryj kafelki lub pokaż je do ostatniego albo wskazanego poziomu kategorii.": "Kacheln ausblenden oder bis zur letzten bzw. einer bestimmten Kategorieebene anzeigen.",
        "Ulica": "Straße",
        "URL płatności": "Zahlungs-URL",
        "Ustal, jak długo i ile ostatnio oglądanych produktów ma pozostać w historii klienta.": "Legen Sie fest, wie lange und wie viele zuletzt angesehene Produkte im Verlauf des Kunden gespeichert werden sollen.",
        "Ustaw czas rezerwacji produktów oraz minimalny i maksymalny poziom logistyczny.": "Legen Sie die Reservierungsdauer für Produkte sowie den minimalen und maximalen Lagerbestand fest.",
        "Ustaw priorytet względem innych grup klientów.": "Legen Sie die Priorität gegenüber anderen Kundengruppen fest.",
        "Ustaw procentową stawkę dla każdego kraju.": "Legen Sie den prozentualen Satz für jedes Land fest.",
        "Ustaw sposób wyświetlania i akceptowania opinii produktów.": "Legen Sie fest, wie Produktbewertungen angezeigt und freigegeben werden.",
        "Ustaw status": "Status festlegen",
        "Ustawienia cechy": "Merkmalseinstellungen",
        "Ustawienia darmowego produktu": "Einstellungen für Gratisprodukte",
        "Ustawienia darmowej dostawy": "Einstellungen für kostenlosen Versand",
        "Ustawienia domyślne": "Standardeinstellungen",
        "Ustawienia eksportu": "Exporteinstellungen",
        "Ustawienia kategorii": "Kategorieneinstellungen",
        "Ustawienia kodu pocztowego": "Postleitzahleneinstellungen",
        "Ustawienia kodu rabatowego": "Rabattcode-Einstellungen",
        "Ustawienia listy": "Listeneinstellungen",
        "Ustawienia podatku": "Steuereinstellungen",
        "Ustawienia podstawowe": "Grundeinstellungen",
        "Ustawienia produktu": "Produkteinstellungen",
        "Ustawienia rabatu": "Rabatteinstellungen",
        "Ustawienia sklepu": "Shop-Einstellungen",
        "Ustawienia sposobu dostawy": "Versandart-Einstellungen",
        "Ustawienia sposobu płatności": "Zahlungsart-Einstellungen",
        "Ustawienia webservice": "Webservice-Einstellungen",
        "Ustawienia zostały zapisane.": "Die Einstellungen wurden gespeichert.",
        "Usuń": "Löschen",
        "Usuń atrybut": "Attribut löschen",
        "Usuń cechę": "Merkmal löschen",
        "Usuń element": "Element löschen",
        "Usuń etykietę": "Etikett löschen",
        "Usuń katalog": "Katalog löschen",
        "Usuń kategorię": "Kategorie löschen",
        "Usuń notatkę": "Notiz löschen",
        "Usuń powiązanie": "Verknüpfung löschen",
        "Usuń producenta": "Hersteller löschen",
        "Usuń produkt z kolekcji": "Produkt aus der Kollektion entfernen",
        "Usuń produkt z promocji": "Produkt aus der Rabattaktion entfernen",
        "Usuń wartość": "Wert löschen",
        "Usuń warunek": "Bedingung löschen",
        "Usun właściwość": "Eigenschaft löschen",
        "Usuń z grupy": "Aus der Gruppe entfernen",
        "Usuń z zestawu": "Aus dem Set entfernen",
        "Usuń zakres": "Bereich löschen",
        "Usunąć ten zakres cen dostawy?": "Möchten Sie diesen Versandpreisbereich löschen?",
        "Utwórz": "Erstellen",
        "Utworzona": "Erstellt",
        "Utworzono": "Erstellt",
        "Uzupełnij wymagane mapowanie pliku CSV.": "Vervollständigen Sie die erforderliche CSV-Dateizuordnung.",
        "Uzupełniono": "Vervollständigt",
        "Użycia": "Verwendungen",
        "Użytkownik": "Benutzer",
        "Użytkownik został odpięty od grupy klientów.": "Der Benutzer wurde aus der Kundengruppe entfernt.",
        "Użytkownik został przypisany do grupy klientów.": "Der Benutzer wurde der Kundengruppe zugewiesen.",
        "Użyty": "Verwendet",
        "vs poprzedni okres": "vs. vorheriger Zeitraum",
        "W magazynie": "Auf Lager",
        "W temacie i treści wiadomości można korzystać z systemu szablonów języka Liquid do parsowania danych pochodzących z zamówienia.": "In Betreff und Nachrichtentext können Sie die Vorlagensprache Liquid verwenden, um Daten aus der Bestellung zu verarbeiten.",
        "W trakcie realizacji": "In Bearbeitung",
        "W trakcie rozpatrywania": "Wird geprüft",
        "Waga": "Gewicht",
        "Waga paczki": "Paketgewicht",
        "Waga produktu": "Produktgewicht",
        "Waga produktu w kilogramach.": "Produktgewicht in Kilogramm.",
        "Waga przygotowanej paczki w kilogramach.": "Gewicht des vorbereiteten Pakets in Kilogramm.",
        "Waluta": "Währung",
        "Waluta rozliczeń sklepu. Jej zmiana wymaga ponownego wyboru kraju.": "Abrechnungswährung des Shops. Wenn Sie sie ändern, muss das Land erneut ausgewählt werden.",
        "Waluta została dodana.": "Die Währung wurde hinzugefügt.",
        "Waluta została usunięta.": "Die Währung wurde gelöscht.",
        "Waluta została zaktualizowana.": "Die Währung wurde aktualisiert.",
        "Waluty": "Währungen",
        "Wariant produktu": "Produktvariante",
        "Wariant został usunięty.": "Die Variante wurde gelöscht.",
        "Warianty": "Varianten",
        "Warianty dodane: {count}": "Hinzugefügte Varianten: {count}",
        "Warianty produktu zostały utworzone.": "Die Produktvarianten wurden erstellt.",
        "Warianty usunięte: {count}": "Gelöschte Varianten: {count}",
        "Wartość": "Wert",
        "Wartość numeryczna": "Numerischer Wert",
        "Wartość przed doliczeniem kosztów dostawy (brutto).": "Wert vor Hinzurechnung der Versandkosten (Brutto).",
        "Wartość rabatu": "Rabattwert",
        "Wartość rabatu (brutto)": "Rabattwert (Brutto)",
        "Wartość tekstowa": "Textwert",
        "Wartość wybierana przy uzupełnianiu cechy produktu. Przygotuj jej wersje językowe.": "Wert, der beim Ausfüllen des Produktmerkmals ausgewählt wird. Bereiten Sie die Übersetzungen vor.",
        "Wartość wymagana": "Wert erforderlich",
        "Wartość z modelu": "Wert aus dem Modell",
        "Wartość zamówień": "Bestellwert",
        "Wartość została dodana.": "Der Wert wurde hinzugefügt.",
        "Wartość została usunięta.": "Der Wert wurde gelöscht.",
        "Wartość została zaktualizowana.": "Der Wert wurde aktualisiert.",
        "Wartości": "Werte",
        "Wartości cechy": "Merkmalswerte",
        "Wartości numeryczne": "Numerische Werte",
        "Wartości procentowe lub kwoty brutto w walucie sklepu.": "Prozentwerte oder Bruttobeträge in der Shopwährung.",
        "Wartości są liczbami całkowitymi. Typ można wybrać tylko podczas tworzenia cechy.": "Die Werte sind Ganzzahlen. Der Typ kann nur beim Erstellen des Merkmals ausgewählt werden.",
        "Warunki": "Bedingungen",
        "Warunki wyświetlania atrybutu": "Bedingungen für die Anzeige des Attributs",
        "Ważna": "Wichtig",
        "Wczytaj": "Laden",
        "Wczytaj cechy ponownie": "Merkmale erneut laden",
        "Wczytanie kategorii zastąpi bieżącą listę produktów.": "Beim Laden der Kategorie wird die aktuelle Produktliste ersetzt.",
        "Wczytano dane z pliku CSV.": "Daten aus der CSV-Datei geladen.",
        "Wczytywanie kategorii": "Kategorie wird geladen",
        "Wersja (version)": "Version (version)",
        "Wersja API": "API-Version",
        "Wewnętrzne informacje dotyczące obsługi zamówienia.": "Interne Informationen zur Auftragsbearbeitung.",
        "Wiadomość": "Nachricht",
        "Widget służy do pobierania kodów promocyjnych z wybranej promocji.": "Das Widget dient zum Abrufen von Rabattcodes aus der ausgewählten Aktion.",
        "Widget służy do wczytania treści powiadomienia według wybranej statusu i wersji językowej.": "Das Widget dient zum Laden des Benachrichtigungstextes für den ausgewählten Status und die ausgewählte Sprache.",
        "Widoczność i położenie": "Sichtbarkeit und Position",
        "Widoczność produktu w modułach z rekomendacjami.": "Sichtbarkeit des Produkts in Empfehlungsmodulen.",
        "Większe lub równe": "Größer oder gleich",
        "Większe niż": "Größer als",
        "Wielkość obramowania": "Rahmengröße",
        "Wielkość tekstu": "Schriftgröße",
        "Wiersze do importu:": "Zu importierende Zeilen:",
        "Witryna": "Website",
        "Witryna i język": "Website und Sprache",
        "Witryny": "Websites",
        "Wklej pełną konfigurację eksportu (name, locale, websiteId, source, format, schema).": "Fügen Sie die vollständige Exportkonfiguration ein (name, locale, websiteId, source, format, schema).",
        "Wklejony tekst nie jest poprawnym JSON.": "Der eingefügte Text ist kein gültiges JSON.",
        "Włącz dni wysyłki i wskaż godzinę dla każdego z nich.": "Aktivieren Sie Versandtage und geben Sie für jeden Tag eine Uhrzeit an.",
        "Włącz dodatkowe pola dla reklamacji": "Zusätzliche Felder für Reklamationen aktivieren",
        "Włącz dostępność metody płatności w krajach i określ jej koszt.": "Aktivieren Sie die Verfügbarkeit der Zahlungsmethode in den Ländern und legen Sie deren Kosten fest.",
        "Włącz, aby w polu daty określić także godzinę rozpoczęcia i zakończenia.": "Aktivieren Sie diese Option, um im Datumsfeld auch eine Start- und Endzeit festzulegen.",
        "Właściwości": "Eigenschaften",
        "Własna wartość": "Benutzerdefinierter Wert",
        "Własny przedział": "Benutzerdefinierter Bereich",
        "Wpis aktywny": "Eintrag aktiv",
        "Wpis aktywny: {name}": "Eintrag aktiv: {name}",
        "Wpis do kalendarza": "Kalendereintrag",
        "Wpis do kalendarza został usunięty.": "Der Kalendereintrag wurde gelöscht.",
        "Wpis do kalendarza został zaktualizowany.": "Der Kalendereintrag wurde aktualisiert.",
        "Wpis w kalendarzu został dodany.": "Der Kalendereintrag wurde hinzugefügt.",
        "Wpis w kalendarzu został zaktualizowany.": "Der Kalendereintrag wurde aktualisiert.",
        "Wpisz liczbę całkowitą. Wartość może być również zerowa lub ujemna.": "Geben Sie eine Ganzzahl ein. Der Wert kann auch null oder negativ sein.",
        "Wpisz treść notatki, maksymalnie 255 znaków.": "Geben Sie den Inhalt der Notiz ein, maximal 255 Zeichen.",
        "Wpisz wartości po przecinku.": "Geben Sie die Werte durch Kommas getrennt ein.",
        "Wpływ na wariantowość produktu": "Einfluss auf Produktvarianten",
        "Wprowadź treść notatki widocznej tylko dla obsługi": "Geben Sie den Inhalt der Notiz ein, die nur für den Kundenservice sichtbar ist",
        "Wszystkie": "Alle",
        "Wszystkie kategorie": "Alle Kategorien",
        "Wszystkie statusy": "Alle Status",
        "Wszystkie wersje językowe zostały już przypisane do innych sklepów.": "Alle Sprachversionen wurden bereits anderen Shops zugewiesen.",
        "Wszystko": "Alles",
        "Wybierz": "Auswählen",
        "Wybierz cechę": "Merkmal auswählen",
        "Wybierz cechę i kliknij plus, aby dodać ją do listy. Zmiany przypisań zostaną utrwalone po zapisaniu grupy.": "Wählen Sie ein Merkmal aus und klicken Sie auf das Plus, um es zur Liste hinzuzufügen. Die Zuordnungsänderungen werden nach dem Speichern der Gruppe übernommen.",
        "Wybierz ceny brutto z podatkiem lub ceny netto bez podatku.": "Wählen Sie Brutto- oder Nettopreise aus.",
        "Wybierz darmowy produkt": "Kostenloses Produkt auswählen",
        "Wybierz element": "Element auswählen",
        "Wybierz element do edycji klikając na niego w strukturze.": "Wählen Sie das zu bearbeitende Element aus, indem Sie in der Struktur darauf klicken.",
        "Wybierz element, aby skonfigurować jego nazwę, wartość i warunki.": "Wählen Sie ein Element aus, um dessen Namen, Wert und Bedingungen zu konfigurieren.",
        "Wybierz etykietę": "Label auswählen",
        "Wybierz etykietę produktu": "Produktlabel auswählen",
        "Wybierz etykietę, którą chcesz przypisać do produktów": "Wählen Sie das Label aus, das Sie den Produkten zuweisen möchten",
        "Wybierz etykiety dostępne w tym sklepie.": "Wählen Sie die in diesem Shop verfügbaren Labels aus.",
        "Wybierz formularz uzupełniający zgłoszenie reklamacyjne.": "Wählen Sie das Formular aus, mit dem die Reklamationsmeldung ergänzt wird.",
        "Wybierz katalog z systemu": "Katalog aus dem System auswählen",
        "Wybierz katalogi używane w sklepie.": "Wählen Sie die im Shop verwendeten Kataloge aus.",
        "Wybierz katalogi, z których sklep ma korzystać przy prezentacji kategorii.": "Wählen Sie die Kataloge aus, die der Shop zur Anzeige von Kategorien verwenden soll.",
        "Wybierz kategorię": "Kategorie auswählen",
        "Wybierz kategorię z przypisanymi cechami, aby uzupełnić ich wartości.": "Wählen Sie eine Kategorie mit zugewiesenen Merkmalen aus, um deren Werte zu ergänzen.",
        "Wybierz kategorię z systemu": "Kategorie aus dem System auswählen",
        "Wybierz kategorię, którą chcesz przypisać do produktów": "Wählen Sie die Kategorie aus, die Sie den Produkten zuweisen möchten",
        "Wybierz kolekcję, którą chcesz przypisać do produktów": "Wählen Sie die Kollektion aus, die Sie den Produkten zuweisen möchten",
        "Wybierz kolumnę.": "Spalte auswählen.",
        "Wybierz kraj, aby zobaczyć dostępne dostawy.": "Wählen Sie ein Land aus, um die verfügbaren Versandarten anzuzeigen.",
        "Wybierz opcję": "Option auswählen",
        "Wybierz opinie dla których chcesz wykonać akcje": "Wählen Sie die Bewertungen aus, für die Sie Aktionen ausführen möchten",
        "Wybierz plik CSV": "CSV-Datei auswählen",
        "Wybierz początek i koniec okresu obowiązywania wpisu.": "Wählen Sie Beginn und Ende des Gültigkeitszeitraums des Eintrags aus.",
        "Wybierz podatek z systemu": "Steuer aus dem System auswählen",
        "Wybierz pozycję i kliknij plus, aby dodać ją do listy.": "Wählen Sie einen Eintrag aus und klicken Sie auf das Plus, um ihn zur Liste hinzuzufügen.",
        "Wybierz producenta": "Hersteller auswählen",
        "Wybierz producenta i kliknij plus. Dodane pozycje są pomijane.": "Wählen Sie einen Hersteller aus und klicken Sie auf das Plus. Bereits hinzugefügte Einträge werden übersprungen.",
        "Wybierz producenta, którego chcesz przypisać do produktów": "Wählen Sie den Hersteller aus, den Sie den Produkten zuweisen möchten",
        "Wybierz produkt": "Produkt auswählen",
        "Wybierz produkty dla których chcesz wykonać akcje": "Wählen Sie die Produkte aus, für die Sie Aktionen ausführen möchten",
        "Wybierz produkty powiązane z tą kolekcją.": "Wählen Sie die Produkte aus, die zu dieser Kollektion gehören.",
        "Wybierz produkty wchodzące w skład zestawu i określ ich ilość.": "Wählen Sie die Produkte aus, die im Set enthalten sein sollen, und legen Sie deren Menge fest.",
        "Wybierz sklep": "Shop auswählen",
        "Wybierz status": "Status auswählen",
        "Wybierz status który chcesz przypisać do opinii": "Wählen Sie den Status aus, den Sie den Bewertungen zuweisen möchten",
        "Wybierz status, który chcesz ustawić w produktach": "Wählen Sie den Status aus, den Sie für die Produkte festlegen möchten",
        "Wybierz status...": "Status auswählen...",
        "Wybierz wartość z listy lub podaj własną.": "Wählen Sie einen Wert aus der Liste aus oder geben Sie einen eigenen ein.",
        "Wybierz witrynę": "Website auswählen",
        "Wybierz zakres dat": "Datumsbereich auswählen",
        "Wybierz zakres godzinowy": "Stundenbereich auswählen",
        "Wybierz zamówienie z listy.": "Bestellung aus der Liste auswählen.",
        "Wybierz źródło": "Quelle auswählen",
        "Wybór strony do przekierowania": "Seite für die Weiterleitung auswählen",
        "Wybrana dostawa i stan przesyłki.": "Ausgewählte Lieferung und Sendungsstatus.",
        "Wybrana kolumna nie zawiera danych.": "Die ausgewählte Spalte enthält keine Daten.",
        "Wybrana kolumna zawiera wartości inne niż liczby.": "Die ausgewählte Spalte enthält Werte, die keine Zahlen sind.",
        "Wybrana kolumna zawiera wartości z nieprawidłowym formatem daty.": "Die ausgewählte Spalte enthält Werte mit einem ungültigen Datumsformat.",
        "Wybrana metoda i rozliczenie płatności.": "Ausgewählte Zahlungsmethode und Zahlungsabrechnung.",
        "Wybrane etykiety": "Ausgewählte Tags",
        "Wybrane pole jest tablicą wartości. W wygenerowanym pliku elementy zostaną połączone przecinkami.": "Das ausgewählte Feld ist ein Array von Werten. In der generierten Datei werden die Elemente durch Kommas getrennt.",
        "Wybrane produkty": "Ausgewählte Produkte",
        "Wybrani producenci": "Ausgewählte Hersteller",
        "Wybranie etykiety produktu jest wymagane": "Die Auswahl eines Produkt-Tags ist erforderlich",
        "Wybranie formatu jest wymagane": "Die Auswahl eines Formats ist erforderlich",
        "Wybranie kategorii jest wymagane": "Die Auswahl einer Kategorie ist erforderlich",
        "Wybranie limitu jest wymagane": "Die Auswahl eines Limits ist erforderlich",
        "Wybranie producenta jest wymagane": "Die Auswahl eines Herstellers ist erforderlich",
        "Wybranie produktu jest wymagane": "Die Auswahl eines Produkts ist erforderlich",
        "Wybrano jedną opinię.": "Eine Bewertung ausgewählt.",
        "Wybranych opinii: %0": "Ausgewählte Bewertungen: %0",
        "Wybranych produktów:": "Ausgewählte Produkte:",
        "Wyczyść cechę we wszystkich językach: {name}": "Merkmal in allen Sprachen leeren: {name}",
        "Wyczyść maksymalną wartość rabatu": "Maximalen Rabattwert leeren",
        "Wyczyść wartość cechy: {name}": "Merkmalswert leeren: {name}",
        "Wygenerowanie nowych kodów spowoduje usunięcie wszystkich istniejących kodów dla tej promocji. Usunięte kody są nieważne i nie można ich już użyć.": "Beim Generieren neuer Codes werden alle vorhandenen Codes für diese Aktion gelöscht. Gelöschte Codes sind ungültig und können nicht mehr verwendet werden.",
        "Wygeneruj feed": "Feed generieren",
        "Wygeneruj z nazwy": "Aus dem Namen generieren",
        "Wygląd etykiety dla wybranej wersji językowej.": "Darstellung des Tags für die ausgewählte Sprachversion.",
        "Wykres kołowy": "Kreisdiagramm",
        "Wykres słupkowy poziomy": "Horizontales Balkendiagramm",
        "Wyłącz wpis, aby nie był aktywny w wybranym okresie.": "Deaktivieren Sie den Eintrag, damit er im ausgewählten Zeitraum nicht aktiv ist.",
        "Wyłącz, aby dezaktywować grupę bez jej usuwania.": "Deaktivieren Sie die Gruppe, ohne sie zu löschen.",
        "Wyłączenie ukrywa opinie w sklepie i blokuje dodawanie nowych.": "Durch Deaktivieren werden Bewertungen im Shop ausgeblendet und das Hinzufügen neuer Bewertungen gesperrt.",
        "Wyłączona promocja nie działa niezależnie od daty.": "Eine deaktivierte Aktion ist unabhängig vom Datum nicht aktiv.",
        "Wymaga uzupełnienia tej cechy w produktach, do których jest przypisana.": "Dieses Merkmal muss in den Produkten ausgefüllt werden, denen es zugewiesen ist.",
        "Wymagalność i format adresu pocztowego.": "Erforderlichkeit und Format der Postleitzahl.",
        "Wymagany kod pocztowy": "Postleitzahl erforderlich",
        "Wymiary etykiety oraz wygląd jej krawędzi.": "Abmessungen des Tags und Darstellung seiner Ränder.",
        "Wysłane": "Gesendet",
        "Wysokość": "Höhe",
        "Wysokość paczki": "Pakethöhe",
        "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "Bei der Verarbeitung des ausgewählten Vorgangs ist ein Serverfehler aufgetreten. Bitte versuchen Sie es erneut.",
        "Wystąpił problem podczas generowania opisu.": "Beim Generieren der Beschreibung ist ein Problem aufgetreten.",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "Im Formular sind Fehler aufgetreten. Überprüfen Sie alle Formularfelder.",
        "Wystawiona ocena": "Abgegebene Bewertung",
        "Wyświetlaj zawartość jako CDATA": "Inhalt als CDATA anzeigen",
        "Wyświetlanie pól": "Felder anzeigen",
        "Wyświetlenia produktu": "Produktaufrufe",
        "Wysyłka na palecie": "Versand auf Palette",
        "Wysyłka: {day}": "Versand: {day}",
        "Wyszukaj cechę...": "Merkmal suchen...",
        "Wyszukaj etykietę...": "Tag suchen...",
        "Wyszukaj etykietę…": "Tag suchen…",
        "Wyszukaj grupę cech…": "Merkmalsgruppe suchen…",
        "Wyszukaj i dodaj etykiety, które mają być dostępne w tym sklepie.": "Suchen Sie nach Tags und fügen Sie die Tags hinzu, die in diesem Shop verfügbar sein sollen.",
        "Wyszukaj kategorię...": "Kategorie suchen...",
        "Wyszukaj kolekcję...": "Kollektion suchen...",
        "Wyszukaj kraj...": "Land suchen...",
        "Wyszukaj kraj…": "Land suchen…",
        "Wyszukaj podatek…": "Steuer suchen…",
        "Wyszukaj producenta...": "Hersteller suchen...",
        "Wyszukaj producenta…": "Hersteller suchen…",
        "Wyszukaj produkt...": "Produkt suchen...",
        "Wyszukaj produkt…": "Produkt suchen…",
        "Wyszukaj rodzaj płatności...": "Zahlungsart suchen...",
        "Wyszukaj sklep...": "Shop suchen...",
        "Wyszukaj sposób dostawy...": "Versandart suchen...",
        "Wyszukaj użytkownika...": "Benutzer suchen...",
        "Wyszukaj walutę...": "Währung suchen...",
        "Wzór kodu pocztowego": "Postleitzahlenformat",
        "Wzór kodu pocztowego, który będzie wyświetlany w komunikacie błędnej walidacji.": "Postleitzahlenformat, das in der Fehlermeldung bei der Validierung angezeigt wird.",
        "z {amount}": "von {amount}",
        "Z adresem email": "Mit E-Mail-Adresse",
        "Zaakceptowane": "Akzeptiert",
        "Zaakceptowany": "Akzeptiert",
        "Zachowaj cenę brutto": "Bruttopreis beibehalten",
        "Zachowaj cenę netto": "Nettopreis beibehalten",
        "Zachowanie przy braku towaru na stanie": "Verhalten bei fehlendem Lagerbestand",
        "zacznij pisac aby wyszukac etykiete...": "beginnen Sie zu tippen, um nach einem Tag zu suchen...",
        "zacznij pisać aby wyszukać kraj...": "beginnen Sie zu tippen, um nach einem Land zu suchen...",
        "zacznij pisac aby wyszukac producenta...": "beginnen Sie zu tippen, um nach einem Hersteller zu suchen...",
        "zacznij pisać aby wyszukać promocję...": "beginnen Sie zu tippen, um nach einer Aktion zu suchen...",
        "zacznij pisać aby wyszukać sklep...": "beginnen Sie zu tippen, um nach einem Shop zu suchen...",
        "zacznij pisać aby wyszukać walutę...": "beginnen Sie zu tippen, um nach einer Währung zu suchen...",
        "zacznij pisac aby wyszukac wartość...": "beginnen Sie zu tippen, um nach einem Wert zu suchen...",
        "zacznij pisac aby wyszukac właściwość...": "beginnen Sie zu tippen, um nach einer Eigenschaft zu suchen...",
        "Zacznij pisać, aby wyszukać cechę…": "Beginnen Sie zu tippen, um nach einem Merkmal zu suchen…",
        "Zaczyna się od": "Beginnt mit",
        "Zakończ edycję adresu": "Adressbearbeitung beenden",
        "Zakres": "Bereich",
        "Zakres dat wpisu": "Datumsbereich des Eintrags",
        "Zakup": "Kauf",
        "Załączniki": "Anhänge",
        "Załaduj": "Laden",
        "Zamawianie bez rejestracji": "Bestellung ohne Registrierung",
        "Zamówienia": "Bestellungen",
        "Zamówienia klienta": "Kundenbestellungen",
        "Zamówienia: {count}": "Bestellungen: {count}",
        "Zamówienie": "Bestellung",
        "Zamówienie firmowe": "Firmenbestellung",
        "Zamówienie wymaga uwagi": "Bestellung erfordert Aufmerksamkeit",
        "Zamówienie wymaga uwagi. Otwórz je, aby sprawdzić szczegóły.": "Die Bestellung erfordert Aufmerksamkeit. Öffnen Sie sie, um die Details zu prüfen.",
        "Zamówienie złożone": "Bestellung aufgegeben",
        "Zamówienie zostało zaktualizowane.": "Die Bestellung wurde aktualisiert.",
        "Zamówiłem(-am) kilka wariantów i zostawiam tylko jeden": "Ich habe mehrere Varianten bestellt und behalte nur eine davon",
        "Zapisane wersje dokumentu.": "Gespeicherte Dokumentversionen.",
        "Zapisuj logi": "Protokolle speichern",
        "Zapisz": "Speichern",
        "Zapisz cechę, aby dodać jej wartości.": "Speichern Sie das Merkmal, um Werte hinzuzufügen.",
        "Zapisz grupę, aby dodać do niej klientów.": "Speichern Sie die Gruppe, um Kunden hinzuzufügen.",
        "Zapisz i wróć": "Speichern und zurück",
        "Zapisz kolejność": "Reihenfolge speichern",
        "Zapisz notatkę": "Notiz speichern",
        "Zapisz promocję, aby zarządzać indywidualnymi kodami.": "Speichern Sie die Aktion, um individuelle Codes zu verwalten.",
        "Zapisz zmiany": "Änderungen speichern",
        "Zapłacono": "Bezahlt",
        "Zapłacono brutto": "Brutto bezahlt",
        "Zarezerwowana ilość": "Reservierte Menge",
        "Zastąp produktami kategorii": "Durch Produkte der Kategorie ersetzen",
        "Zastosowanie konfiguracji usunie warianty niepasujące do wybranych wartości.": "Durch Anwenden der Konfiguration werden Varianten entfernt, die nicht den ausgewählten Werten entsprechen.",
        "Zastosuj": "Anwenden",
        "Zawartość elementu": "Inhalt des Elements",
        "Zawiera": "Enthält",
        "Zawiera produkt": "Enthält Produkt",
        "Zaznacz dostępne sposoby dostawy. Pod każdym widać przypisane formy płatności; nieaktywne dostawy pozostają zablokowane.": "Wählen Sie die verfügbaren Versandarten aus. Unter jeder werden die zugewiesenen Zahlungsarten angezeigt; nicht aktive Versandarten bleiben gesperrt.",
        "Zaznacz wersje językowe witryn obsługiwane przez sklep. Wersje przypisane do innych sklepów są zablokowane.": "Wählen Sie die von Ihrem Shop unterstützten Sprachversionen der Websites aus. Sprachversionen, die anderen Shops zugewiesen sind, sind gesperrt.",
        "Zaznaczona kategoria jest kategorią główną produktu.": "Die ausgewählte Kategorie ist die Hauptkategorie des Produkts.",
        "Zdecyduj, na jakich poziomach katalogu klient zobaczy kafelki kategorii.": "Legen Sie fest, auf welchen Katalogebenen dem Kunden Kacheln für Kategorien angezeigt werden.",
        "Zdezaktywowany": "Deaktiviert",
        "Zdjęcia": "Bilder",
        "Zdjęcie": "Bild",
        "Zdjęcie główne": "Hauptbild",
        "Ze statusu": "Aus Status",
        "Zestaw": "Set",
        "Zewnętrzna głębokość przygotowanej paczki w centymetrach.": "Außenlänge des vorbereiteten Pakets in Zentimetern.",
        "Zewnętrzna szerokość przygotowanej paczki w centymetrach.": "Außenbreite des vorbereiteten Pakets in Zentimetern.",
        "Zewnętrzna wysokość przygotowanej paczki w centymetrach.": "Außenhöhe des vorbereiteten Pakets in Zentimetern.",
        "Zmiana statusu": "Statusänderung",
        "Zmiany zostały zapisane.": "Die Änderungen wurden gespeichert.",
        "Zmień kolejność wartości cechy": "Reihenfolge der Merkmalswerte ändern",
        "Zmień nazwę katalogu": "Katalog umbenennen",
        "Zmień status": "Status ändern",
        "Zmodyfikowane przez": "Geändert von",
        "Zniżka została usunięta.": "Der Rabatt wurde gelöscht.",
        "Zrealizowane": "Abgeschlossen",
        "Żródła": "Quellen",
        "Źródło": "Quelle",
        "Źródło (utm_source)": "Quelle (utm_source)",
        "Źródło danych": "Datenquelle",
        "Źródło pochodzenia statusu": "Quelle des Statusursprungs",
        "Źródło zdarzenia, temat i treść wiadomości.": "Ereignisquelle, Betreff und Inhalt der Nachricht.",
        "Zwolniono": "Freigegeben",
        "Zwrot": "Rückerstattung",
        "Zwroty": "Rückerstattungen",
        "zwroty / zamówienia": "Rückerstattungen / Bestellungen",
        "Zwykły tekst": "Klartext"
    }
};
